/* syn-kit.js v2.88 - extracted verbatim from snippets/synergy-product-kit.liquid (v2.85) on 2026-09-23 so browsers can cache it.
   v2.87 (2026-09-23 speed pass 2): reel thumbnails painted when the reel widget nears the screen (see the v2.20 ReelUp block).
   v2.88 (2026-10-05): the three ANCORE products cross-sell each other in the native strip (see ANCORE_FAMILY).
   v2.89 (2026-10-05): Chris: "improve the look of the complete ancore setup. make it look premium". ANCORE pages
   draw one composed card (buildAncoreSetup) instead of the carousel strip.
   v2.90 (2026-10-05): the option-tap photo crossfade no longer flashes a full-size image (ghost needed a positioned box).
   Loaded SYNCHRONOUSLY (no defer, no async) from snippets/synergy-product-kit.liquid, on purpose: with defer the kit ran
   after first paint and its placement counted as layout shift. Every block is a self-contained IIFE; order preserved. */

(function() {
  'use strict';

  // Matches both PwzrButton-sizeSmall (verticals) and PwzrButton-textSizeSmall (horizontals)
  var BTN_SELECTOR = '[class*="PwzrButton-sizeSmall"], [class*="PwzrButton-textSizeSmall"]';

  // Colors WE apply. Used to tell apart "the theme set this background" from
  // "we set this background". Anything not in this set is a theme-driven color.
  var SYN_BG = {
    'rgb(38, 177, 253)': 1,  // #26B1FD selected
    'rgb(247, 247, 247)': 1, // #f7f7f7 available
    'rgb(239, 239, 239)': 1  // #efefef disabled
  };

  function styleRackButtons() {
    var probe = document.querySelectorAll('.rio-options ' + BTN_SELECTOR);
    if (probe.length === 0) { setTimeout(styleRackButtons, 120); return; }

    // The theme renders ALL option buttons (Tiers, Width, Add-on, Mounting
    // Hardware, etc.) inside a single .rio-options container. Each option axis
    // does live inside its own PwzrGrid-root wrapper, however, which we use
    // for grouping. Selection within each group is detected by reading the
    // theme's live inline background-color before we repaint.

    // v2.4 (June 30, 2026): groupKey() now identifies the option group by
    // walking up the DOM to the shared PwzrGrid-root container. Earlier text-
    // pattern matching mis-classified values containing digits + quote chars
    // (e.g. "1" Holes Rack Mount", "5/8" Holes Rack Mount") as "width" and
    // split them away from sibling values like "Wall Mount", which broke
    // single-selection on the Delta 10-Tier Wall/Rack Mount and any future
    // product with a similar option axis.
    function groupKey(btn) {
      // PRIMARY: group by the option's PwzrGrid container (DOM-structure based).
      // Each Power Picker option (Color, Mounting Hardware, Tier, Width, Add-on,
      // etc.) renders its buttons inside its own PwzrGrid-root wrapper. Walking
      // up to find that wrapper is the most reliable way to group siblings
      // together regardless of how their labels happen to be worded.
      var current = btn.parentElement;
      while (current && current !== document.body) {
        if (current.className && /PwzrGrid-root-\d+/.test(current.className)) {
          var btnsInside = current.querySelectorAll('[class*="PwzrButton-sizeSmall"], [class*="PwzrButton-textSizeSmall"]');
          if (btnsInside.length > 1) {
            var m = current.className.match(/PwzrGrid-root-\d+/);
            if (m) return 'grid:' + m[0];
          }
        }
        current = current.parentElement;
      }

      // FALLBACK: legacy text-pattern grouping for edge cases where DOM
      // grouping couldn't find a multi-button PwzrGrid ancestor (e.g.
      // single-variant axes or unexpected DOM layouts).
      var t = (origText(btn) || '').toLowerCase();
      if (t.indexOf('tier') > -1 && t.indexOf('horizontal') > -1) return 'rack';
      if (t.indexOf('add-on') > -1 || t.indexOf('add on') > -1) return 'addon';
      if (/\d+\s*["?]/.test(t) || t.indexOf('width') > -1) return 'width';
      if (t.indexOf('tier') > -1) return 'rack';
      return 'other';
    }

    // Returns the ORIGINAL button label (before any display relabel), so group
    // detection stays correct even after we shorten "Vertical Add-on: Yes" to "Yes".
    function origText(btn) {
      var spans = btn.querySelectorAll('span');
      var stored = null, live = '';
      spans.forEach(function(sp) {
        var o = sp.getAttribute('data-syn-orig');
        if (o !== null) stored = o;
        var hasText = false;
        sp.childNodes.forEach(function(n) {
          if (n.nodeType === 3 && n.textContent.trim()) hasText = true;
        });
        if (hasText) live = sp.textContent.trim();
      });
      return stored !== null ? stored : (live || btn.textContent);
    }

    function getButtons() {
      return document.querySelectorAll('.rio-options ' + BTN_SELECTOR);
    }

    // Per-group, find the selected button by detecting which one the theme has
    // painted with a NON-synergy background color (i.e. the theme's own highlight).
    // We remember it on a data attribute so that once we repaint everything, the
    // selection memory survives until the theme changes it again.
    function refreshSelectionMemory() {
      var btns = getButtons();
      var groups = {};
      btns.forEach(function(btn) {
        var key = groupKey(btn);
        (groups[key] = groups[key] || []).push(btn);
      });
      Object.keys(groups).forEach(function(key) {
        var list = groups[key];
        var themePicked = null;
        list.forEach(function(btn) {
          var bg = '';
          try { bg = getComputedStyle(btn).backgroundColor || ''; } catch (e) {}
          // A theme-driven color is any background that is NOT one of ours and
          // NOT transparent/white default.
          if (bg && !SYN_BG[bg] && bg !== 'rgba(0, 0, 0, 0)' &&
              bg !== 'transparent' && bg !== 'rgb(255, 255, 255)') {
            themePicked = btn;
          }
        });
        if (themePicked) {
          // Clear old memory in this group, set new
          list.forEach(function(b) { b.removeAttribute('data-syn-selected'); });
          themePicked.setAttribute('data-syn-selected', '1');
        } else {
          // No theme color visible (we already painted, or nothing chosen yet).
          // If nothing in this group is remembered as selected, leave as-is.
          var anyRemembered = list.some(function(b) {
            return b.getAttribute('data-syn-selected') === '1';
          });
          if (!anyRemembered && list.length) {
            // Default: assume first available (non aria-disabled) is selected so
            // the group never looks empty. The theme will correct us on first paint.
            for (var i = 0; i < list.length; i++) {
              if (list[i].getAttribute('aria-disabled') !== 'true') {
                list[i].setAttribute('data-syn-selected', '1');
                break;
              }
            }
          }
        }
      });
    }

    // Display-only relabel: the variant value in Shopify must stay verbose
    // (e.g. "Vertical Add-on: Yes") so the packing team sees the full name on
    // orders. But on the page that prefix is redundant under the "Pick Your
    // Vertical Add-on" heading. Rewrite ONLY the visible text node, never the
    // variant data, so checkout/order still carries the full value.
    function relabel(btn) {
      // Find the deepest span that directly contains the text
      var spans = btn.querySelectorAll('span');
      var textSpan = null;
      spans.forEach(function(sp) {
        var hasText = false;
        sp.childNodes.forEach(function(n) {
          if (n.nodeType === 3 && n.textContent.trim()) hasText = true;
        });
        if (hasText) textSpan = sp;
      });
      if (!textSpan) return;

      var original = textSpan.getAttribute('data-syn-orig');
      if (original === null) {
        original = textSpan.textContent.trim();
        textSpan.setAttribute('data-syn-orig', original);
      }

      var cleaned = cleanLabel(original);
      if (cleaned && cleaned !== textSpan.textContent) {
        textSpan.textContent = cleaned;
      }
    }

    // Option B: shape-based cleanup. Removes the redundant "Vertical Add-on"
    // phrasing in whatever position it appears, across all naming conventions:
    //   "Vertical Add-on: Yes"                             -> "Yes"
    //   "Vertical Add-on: No"                              -> "No"
    //   "Vertical Add-on: Yes. Alpha (holds 50lb...)"      -> "Yes. Alpha (holds 50lb...)"
    //   "No Vertical Add-on"                               -> "No"
    //   "1 Set (2 pcs) Vertical Add-on"                    -> "1 Set (2 pcs)"
    //   "2 Sets (4 pcs) Vertical Add-on"                   -> "2 Sets (4 pcs)"
    // Never returns empty: if cleanup would blank the label, the original is kept.
    function cleanLabel(text) {
      if (!text) return text;
      var s = text;

      // 1. "Prefix: value" drops the prefix segment (only when prefix is short
      //    and the value after the colon is non-empty)
      var colon = s.match(/^([^:]{1,40}):\s*(.+)$/);
      if (colon && colon[2].trim()) {
        s = colon[2].trim();
      }

      // 2. Remove a leading or trailing standalone "Vertical Add-on" phrase
      //    (handles "No Vertical Add-on" / "1 Set (2 pcs) Vertical Add-on")
      s = s.replace(/^\s*vertical\s+add-?on\s*[:\-]?\s*/i, '');
      s = s.replace(/\s*[:\-]?\s*vertical\s+add-?on\s*$/i, '');

      // 3. Collapse leftover whitespace/punctuation edges
      s = s.replace(/\s{2,}/g, ' ').replace(/^[\s.\-,:]+|[\s.\-,:]+$/g, '').trim();

      // Safety: never return an empty string. Fall back to the original.
      if (!s) return text;
      return s;
    }

    function paint() {
      var btns = getButtons();
      btns.forEach(function(btn) {
        relabel(btn);
        var isSelected = btn.getAttribute('data-syn-selected') === '1';
        var isDisabled = btn.getAttribute('aria-disabled') === 'true';

        btn.style.setProperty('border', 'none', 'important');
        btn.style.setProperty('border-radius', '20px', 'important');

        var bg, txt, deco, weight;
        if (isSelected) {
          bg = '#26B1FD'; txt = '#ffffff'; deco = 'none'; weight = '700';
        } else if (isDisabled) {
          bg = '#efefef'; txt = '#9a9a9a'; deco = 'line-through'; weight = '400';
        } else {
          bg = '#f7f7f7'; txt = '#555555'; deco = 'none'; weight = '400';
        }

        btn.style.setProperty('background-color', bg, 'important');
        btn.style.setProperty('color', txt, 'important');
        btn.style.setProperty('opacity', '1', 'important');
        btn.style.setProperty('text-decoration', deco, 'important');
        btn.style.setProperty('font-weight', weight, 'important');

        // The theme sets text color as an inline style on the inner <span>.
        // That span color beats the button color, so force it on every span.
        var spans = btn.querySelectorAll('span');
        spans.forEach(function(sp) {
          sp.style.setProperty('color', txt, 'important');
          sp.style.setProperty('text-decoration', deco, 'important');
          sp.style.setProperty('font-weight', weight, 'important');
        });
      });
    }

    // Each cycle: read the theme's selection FIRST (before we repaint), then paint.
    function tick() {
      refreshSelectionMemory();
      paint();
    }

    // On user click, the theme updates its own background async. Re-read shortly
    // after so we capture the new selection before the next repaint.
    function onInteract() {
      // brief delays let the theme apply its highlight, which we then capture
      setTimeout(refreshSelectionMemory, 30);
      setTimeout(tick, 60);
      setTimeout(tick, 160);
    }

    tick();
    probe.forEach(function(btn) {
      ['click', 'mouseup', 'keyup'].forEach(function(evt) {
        btn.addEventListener(evt, onInteract);
      });
    });
    // Also catch programmatic / variant-driven changes
    document.addEventListener('click', function(e) {
      if (e.target && e.target.closest && e.target.closest('.rio-options')) {
        onInteract();
      }
    }, true);

    setInterval(tick, 250);
  }

  var colorData = {
    'Black': '#161618',
    'Synergy Blue': '#31A3EB',
    'White': '#FFFFFF',
    'Red': '#C51907',
    'Grey': '#555555',
    'Orange': '#EE5412',
    'Yellow': '#FFE705',
    'Blue': '#0C68F5',
    'Military Green': '#4D603B',
    'Military Tan': '#D1B99A',
    'Hot Pink': '#FF5598',
    'Purple': '#8e44ad',
    // Limited Edition. Value is a CSS gradient string (not a hex) so it must
    // be applied via .style.background (shorthand), not .style.backgroundColor.
    'Stainless Steel': 'linear-gradient(135deg, #B8B8B8 0%, #EEEEEE 30%, #808080 50%, #F5F5F5 70%, #A0A0A0 100%)'
  };

  var groups = [
    { cls: 'syn-pill--best', label: 'Best Seller', colors: ['Black'], row: 1 },
    { cls: 'syn-pill--spec', label: 'Specialty', colors: ['Synergy Blue', 'White', 'Red', 'Grey', 'Orange', 'Yellow', 'Blue', 'Military Green', 'Military Tan', 'Hot Pink', 'Purple'], row: 2 },
    { cls: 'syn-pill--limited', label: 'Limited Edition', colors: ['Stainless Steel'], row: 3 }
  ];

  function findContainer() {
    var btn = document.querySelector('[aria-label="Synergy Blue"][class*="PwzrButton"]');
    if (!btn) return null;
    var el = btn;
    for (var i = 0; i < 10; i++) {
      el = el.parentElement;
      if (el.parentElement && el.parentElement.children.length >= 10) return el.parentElement;
    }
    return null;
  }

  function getSelectedColor() {
    var container = findContainer();
    if (!container) return null;
    var btns = container.querySelectorAll('[aria-label][class*="PwzrButton"]');
    var selected = null;
    btns.forEach(function(btn) {
      var border = btn.style.borderColor || '';
      var computed = getComputedStyle(btn).borderColor || '';
      var color = border || computed;
      var match = color.match(/rgb\((\d+)/);
      if (match && parseInt(match[1]) < 100) {
        selected = btn.getAttribute('aria-label');
      }
    });
    return selected;
  }

  function clickOriginal(colorName) {
    var container = findContainer();
    if (!container) return;
    var btn = container.querySelector('[aria-label="' + colorName + '"][class*="PwzrButton"]');
    if (btn) btn.click();
  }

  /* v2.74: this runs on a 1s setInterval, forever. Two faults, both
     measured on the live site with a MutationObserver:

     (a) It rewrote the class attribute of all 12 swatches on EVERY tick
         even when nothing had changed - 12 attribute mutations a second
         with identical old and new values, for the life of the page.
     (b) getSelectedColor() infers the selection by sampling a third
         party button's BORDER COLOUR. Whenever that read fails it
         returns null, and this function then stripped syn-swatch-active
         from the selected swatch - which the next tick put back. That
         is a selection ring blinking once a second, in the option
         picker area, which is exactly what Chris reported as vibrating.

     Now: a failed read changes nothing at all, and the class is only
     touched when its state genuinely differs. Same rule as v2.72 - a
     function called repeatedly for idempotence must be SILENT when
     nothing changed. */
  function updateActiveState() {
    var selected = getSelectedColor();
    if (!selected) return;
    document.querySelectorAll('.syn-swatch').forEach(function(s) {
      var want = (s.dataset.color === selected);
      if (s.classList.contains('syn-swatch-active') !== want) {
        s.classList.toggle('syn-swatch-active', want);
      }
    });
  }

  /* v2.77: FAIL OPEN. This snippet's own CSS hides .rio-options at
     opacity 0 and only reveals it when buildPills() finishes. But
     findContainer() locates the picker by querying for a "Synergy Blue"
     swatch, so on ANY product with no Synergy Blue option the container
     is never found, the retry below loops forever, .syn-ready never
     lands, and THE ENTIRE VARIANT PICKER stays permanently invisible -
     not just our pills. Every PRx resale item is in that state, which
     is why Chris sees no options on those pages.
     This exact bug shipped once before (2026-08-11, six horizontal
     templates with no Color option) and was patched with per-template
     CSS instead of here, on the reasoning that a shared-snippet edit
     had too big a blast radius. That decision is what let it come back
     the moment the kit started loading on PRx pages. Fixing it at the
     source this time.
     A HIDE MUST NEVER OUTLIVE THE THING IT WAS HIDING FOR. Two
     independent guarantees: the retry below is bounded and reveals on
     give-up, and an unconditional deadline reveals regardless. */
  function revealRio() {
    var list = document.querySelectorAll('.rio-options');
    for (var i = 0; i < list.length; i++) {
      if (!list[i].classList.contains('syn-ready')) list[i].classList.add('syn-ready');
    }
  }
  setTimeout(revealRio, 8000);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(revealRio, 8000); });
  }

  /* v2.78: Chris, on the v2.77 preview: "it takes like 5 seconds for the
     variations to load in." The fail-open worked but it was waiting out
     the whole retry budget before firing, because the ONLY signal it had
     was "we still have not found a Synergy Blue swatch", which never
     becomes true on a PRx page and never becomes false either. A
     TIMEOUT IS A LAST RESORT, NOT A BRANCH - if the page can already
     tell you the answer, ask it.
     It can: once ProductWiz has painted ANY swatch, the picker has
     mounted. If a Synergy Blue one is not among them shortly after, this
     product has no Synergy Blue option and our pills can never build, so
     there is nothing left to wait for. Reveal now.
     The short grace after the first button exists because ProductWiz
     paints swatches progressively, and revealing on the very first one
     would flash the raw picker on a Synergy product a beat before our
     pills replace it. */
  var rioBtnsSeenAt = 0;

  function buildPills(attempt) {
    attempt = attempt || 0;
    if (document.querySelector('.syn-pills-wrapper')) return;
    var container = findContainer();
    if (!container) {
      if (document.querySelector('[class*="PwzrButton"]')) {
        if (!rioBtnsSeenAt) { rioBtnsSeenAt = Date.now(); }
        else if (Date.now() - rioBtnsSeenAt > 700) { revealRio(); return; }
      }
      /* backstop only: 60 x 120ms = 7.2s */
      if (attempt >= 60) { revealRio(); return; }
      setTimeout(function () { buildPills(attempt + 1); }, 120);
      return;
    }
    var scrollParent = container.closest('[class*="rio-hide-scrollbar"]');
    if (scrollParent) {
      scrollParent.style.height = '0px';
      scrollParent.style.overflow = 'hidden';
      scrollParent.style.opacity = '0';
      scrollParent.style.position = 'absolute';
    }
    var colorHeading = null;
    var allEls = document.querySelectorAll('*');
    for (var i = 0; i < allEls.length; i++) {
      var direct = '';
      allEls[i].childNodes.forEach(function(n) { if (n.nodeType === 3) direct += n.textContent.trim(); });
      if (direct === 'Pick Your Color') { colorHeading = allEls[i]; break; }
    }
    var insertTarget = colorHeading ? colorHeading.parentElement : container.parentElement;
    var wrapper = document.createElement('div');
    wrapper.className = 'syn-pills-wrapper';

    // v2.6: Rows are lazy-created so a row with zero valid pills (e.g. Limited
    // Edition on a product that doesn't have Stainless Steel) never renders.
    var rows = {};

    groups.forEach(function(group) {
      // v2.6: Only include colors whose Power Picker variant actually exists
      // on THIS product. Prevents dead swatches (which would silently no-op)
      // and lets the same kit power all products regardless of which colors
      // each product offers.
      var validColors = group.colors.filter(function(c) {
        return container.querySelector('[aria-label="' + c + '"][class*="PwzrButton"]');
      });
      if (validColors.length === 0) return;

      if (!rows[group.row]) {
        rows[group.row] = document.createElement('div');
        rows[group.row].className = 'syn-pills-row';
      }

      var pill = document.createElement('div');
      pill.className = 'syn-pill ' + group.cls;
      var label = document.createElement('span');
      label.className = 'syn-pill-label';
      label.textContent = group.label;
      pill.appendChild(label);
      var swatches = document.createElement('div');
      swatches.className = 'syn-pill-swatches';
      validColors.forEach(function(c) {
        var swatch = document.createElement('div');
        swatch.className = 'syn-swatch';
        swatch.dataset.color = c;
        // v2.6: Use `background` shorthand instead of `backgroundColor` so a
        // colorData value can be either a hex string (existing colors) or a
        // CSS gradient string (Stainless Steel, plus any future limited SKUs).
        swatch.style.background = colorData[c] || '#ccc';
        if (c === 'White') swatch.style.border = '2px solid #ccc';
        swatch.addEventListener('click', function() {
          clickOriginal(c);
          setTimeout(updateActiveState, 100);
        });
        swatches.appendChild(swatch);
      });
      pill.appendChild(swatches);
      rows[group.row].appendChild(pill);
    });

    // Append rows in numeric order, skipping any that never got created.
    Object.keys(rows).map(Number).sort(function(a, b) { return a - b; }).forEach(function(n) {
      wrapper.appendChild(rows[n]);
    });

    if (colorHeading) {
      insertTarget.insertBefore(wrapper, colorHeading.nextSibling);
    } else {
      insertTarget.appendChild(wrapper);
    }
    setTimeout(updateActiveState, 200);
    setInterval(updateActiveState, 1000);
    revealRio();
  }

  function earlyHide() {
    var container = findContainer();
    if (container) {
      var scrollParent = container.closest('[class*="rio-hide-scrollbar"]');
      if (scrollParent) {
        scrollParent.style.height = '0px';
        scrollParent.style.overflow = 'hidden';
        scrollParent.style.opacity = '0';
        scrollParent.style.position = 'absolute';
      }
    } else {
      requestAnimationFrame(earlyHide);
    }
  }
  requestAnimationFrame(earlyHide);

  /* v2.20: ReelUp perceived-speed fix. Two facts measured on the live Delta
     PDP: the app's script loads from cdn-v2.reelup.io, a host the theme
     never preconnects (its old CloudFront host is preconnected instead),
     and every reel already ships a thumbnail jpg in the server-rendered
     window.REELUP data that the cards never use - they sit as blank
     skeletons until video actually buffers (~8 MB of preview clips per
     page). Open the connection early, and paint each card with its own
     thumbnail immediately so the section reads as loaded while the videos
     stream in behind. The app replaces the skeletons when players mount,
     so this never fights it. */
  (function () {
    var pc = document.createElement('link');
    pc.rel = 'preconnect'; pc.href = 'https://cdn-v2.reelup.io'; pc.crossOrigin = '';
    document.head.appendChild(pc);
    function paintReelThumbs(root) {
      var R = window.REELUP;
      var slides = (root || document).querySelectorAll('.reelUp_slide[data-reel-id]');
      if (!slides.length) return;
      if (!R || !R.videos || !R.videos.length) { setTimeout(function () { paintReelThumbs(root); }, 250); return; }
      var map = {};
      R.videos.forEach(function (v) { if (v && v.id) map[v.id] = v.thumbnail; });
      slides.forEach(function (s) {
        var t = map[s.getAttribute('data-reel-id')];
        var sk = s.querySelector('.reelUp_card_skeleton');
        if (t && sk && !sk.dataset.synThumb) {
          sk.dataset.synThumb = 'true';
          sk.style.backgroundImage = 'url(' + t + ')';
          sk.style.backgroundSize = 'cover';
          sk.style.backgroundPosition = 'center';
        }
      });
    }
    /* 2026-09-23 speed pass 2 (kit v2.87): paint each reel widget's thumbnails when it comes within 2500 px of the
       screen, on the shopper's first scroll, or 1 s after load, whichever is first (was: all at DOMContentLoaded,
       which pulled 430-590 KB of thumbnails into the load window on pages whose reels are 6-7 screens down). */
    function synGate(paint){var slides=document.querySelectorAll('.reelUp_slide[data-reel-id]');if(!slides.length)return;var hosts=[];slides.forEach(function(s){var h=s.closest('.shopify-section')||s.parentNode;if(hosts.indexOf(h)<0)hosts.push(h)});var io=null,done=false;function all(){if(done)return;done=true;if(io)hosts.forEach(function(h){io.unobserve(h)});hosts.forEach(function(h){paint(h)})}if(!('IntersectionObserver' in window)||window.scrollY>0){all();return}io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){io.unobserve(e.target);paint(e.target)}})},{rootMargin:'2500px 0px'});hosts.forEach(function(h){io.observe(h)});window.addEventListener('scroll',all,{once:true,passive:true});window.addEventListener('load',function(){setTimeout(all,1000)})}
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { synGate(paintReelThumbs); });
    } else {
      synGate(paintReelThumbs);
    }
  })();

  /* v2.22: the badges used to render visible in their authored position and
     then get MOVED next to the buy buttons 800ms after page-ready - Chris
     saw them "glitch in and out", and the speed pass made the page paint
     early enough to expose it. Now: hidden until the frame they land in
     their final position (CSS keys off data-syn-moved), retried per
     animation frame instead of on a 500ms timer, and if the buy buttons
     never materialize the badges reveal in place after ~15s so content is
     never lost. */
  function moveElements(attempt) {
    attempt = attempt || 0;
    var buyButtons = document.querySelector('.product-form__buy-buttons');
    var badges = document.querySelector('.syn-badges');
    if (!badges) {
      if (attempt < 900) requestAnimationFrame(function () { moveElements(attempt + 1); });
      return;
    }
    if (!buyButtons) {
      if (attempt < 900) { requestAnimationFrame(function () { moveElements(attempt + 1); }); return; }
      badges.dataset.synMoved = 'true';   /* failsafe: reveal where authored */
      return;
    }
    /* v2.17: returns badge sub-line copy change, approved 2026-08-12 */
    badges.querySelectorAll('.syn-badge-sub').forEach(function (el) {
      if (el.textContent.trim() === 'Hassle-free policy') el.textContent = 'From delivery date';
    });
    /* v2.19: payment terms are hidden again (see CSS), so the v2.16 code
       that relocated the form's shopify-payment-terms into the buy-buttons
       area is gone - no point moving an element that never shows. */
    if (!badges.dataset.synMoved) {
      buyButtons.parentElement.insertBefore(badges, buyButtons.nextSibling);
      badges.dataset.synMoved = 'true';
    }
  }

  // v2.10: Move the trust strip to right before the variant picker on load.
  // Impulse's product template renders the variant picker (rio-options) in a
  // hardcoded position ahead of Custom Liquid blocks in the same section, so
  // dragging the block above in the customizer does NOT move the trust strip
  // above the picker on the rendered page. We correct that here by hoisting
  // the trust strip (and its .product-form__custom-liquid wrapper) to sit
  // immediately before .rio-options. Same pattern used by moveElements() to
  // reposition .syn-badges next to the buy buttons.
  /* v2.23: the strip no longer waits for the productwiz picker at all. The
     picker (rio-options) mounts client-side seconds after paint, and it
     always injects itself immediately BEFORE the theme's native variant
     picker (product-variants / .product-form__variants), which IS
     server-rendered and present from first paint. So the strip's final
     home can be reached instantly: place it before the native element at
     page-ready, and when rio mounts it slots in between - strip above
     picker, exactly the design, with the strip itself never moving again.
     v2.22's version anchored on rio and kept the strip hidden until the
     picker mounted, which read as a LATER pop-in, not a better one. */
  function moveTrustStripBeforeVariants(attempt) {
    attempt = attempt || 0;
    var trust = document.querySelector('.syn-trust');
    if (!trust) {
      if (attempt < 900) requestAnimationFrame(function () { moveTrustStripBeforeVariants(attempt + 1); });
      return;
    }
    if (trust.dataset.synTrustMoved === 'true') return;
    /* The theme renders product-variants TWICE for the same form: once in
       the sticky add-to-cart bar and once in the buy box. Only the buy-box
       copy is a valid anchor - the sticky one must be excluded or the
       strip lands inside the sticky bar on loads where the picker has not
       mounted yet. */
    function firstNonSticky(sel) {
      var list = document.querySelectorAll(sel);
      for (var i = 0; i < list.length; i++) {
        if (!list[i].closest('.product-sticky-form')) return list[i];
      }
      return null;
    }
    var anchor = document.querySelector('.rio-options') ||
                 firstNonSticky('product-variants') ||
                 firstNonSticky('.product-form__variants') ||
                 firstNonSticky('.product-form');
    if (!anchor) {
      if (attempt < 240) { requestAnimationFrame(function () { moveTrustStripBeforeVariants(attempt + 1); }); return; }
      trust.dataset.synTrustMoved = 'true';   /* failsafe: reveal where authored */
      return;
    }
    var trustWrapper = trust.closest('.product-form__custom-liquid') || trust;
    anchor.parentElement.insertBefore(trustWrapper, anchor);
    trust.dataset.synTrustMoved = 'true';
  }

  // v2.15: Variant-conditional note system. Any product page can include a
  // .syn-variant-note element with data-variant-match="<substring>". The kit
  // moves the note into the picker on load and toggles its visibility based
  // on whether any selected variant label contains the match substring.
  function initVariantNotes() {
    var notes = document.querySelectorAll('.syn-variant-note');
    if (notes.length === 0) return;
    var rio = document.querySelector('.rio-options');
    if (!rio) { setTimeout(initVariantNotes, 200); return; }

    // Move each note to the bottom of the variant picker.
    notes.forEach(function(note) {
      if (note.dataset.synNoteMoved === 'true') return;
      note.dataset.synNoteMoved = 'true';
      rio.appendChild(note);
    });

    // Wire up observers so the note toggles on any variant change.
    if (rio.dataset.synNoteHandler !== 'true') {
      rio.dataset.synNoteHandler = 'true';
      var obs = new MutationObserver(function() { updateVariantNotes(); });
      obs.observe(rio, { subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
      rio.addEventListener('click', function() {
        setTimeout(updateVariantNotes, 100);
      });
    }

    updateVariantNotes();
  }

  function updateVariantNotes() {
    var notes = document.querySelectorAll('.syn-variant-note');
    if (notes.length === 0) return;

    // Collect the labels of every currently-selected variant button.
    var selectedTexts = [];
    document.querySelectorAll('.rio-options [class*="PwzrButton"]').forEach(function(btn) {
      var cls = (btn.className || '').toLowerCase();
      var bg = getComputedStyle(btn).backgroundColor;
      var isSelected = cls.indexOf('selected') !== -1 ||
                       cls.indexOf('active') !== -1 ||
                       bg.indexOf('38, 177, 253') !== -1;
      if (isSelected) {
        var text = (btn.textContent || '').trim();
        if (text) selectedTexts.push(text);
      }
    });
    var joinedText = selectedTexts.join(' | ');

    notes.forEach(function(note) {
      var match = note.dataset.variantMatch;
      if (!match) return;
      var shouldShow = joinedText.indexOf(match) !== -1;
      note.style.display = shouldShow ? 'block' : 'none';
    });
  }

  function moveRebuyIntoWrap() {
    var wrap = document.querySelector('.syn-rebuy-wrap');
    var rebuy = findRealRebuy();
    if (wrap && rebuy && !wrap.contains(rebuy)) {
      wrap.appendChild(rebuy);
      rebuy.style.opacity = '1';
      document.documentElement.classList.add('syn-rbr-ready');
      return true;
    }
    return false;
  }

  // v2.5: Walk EVERY .rbr-desktop on the page and return the first one that
  // has real bundle content (product + price + checkbox), or null. Rebuy
  // sometimes injects an empty shell alongside the real widget, and blind
  // first-match on document.querySelector('.rbr-desktop') would pick the
  // empty shell and cause the kit to collapse the entire panel.
  function findRealRebuy() {
    var candidates = document.querySelectorAll('.rbr-desktop');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      var textLen = (el.textContent || '').replace(/\s+/g, '').length;
      var hasPrice = /\$\s?\d/.test(el.textContent || '');
      var hasCheckbox = el.querySelector('input[type="checkbox"]');
      var rect = el.getBoundingClientRect();
      // scrollHeight beats rect.height once the widget has been collapsed
      // with max-height:0 (rect.height goes to 0 even when content exists).
      var rendersTall = (el.scrollHeight || 0) > 20 || (rect && rect.height > 20);
      var hasRealContent = (hasPrice && textLen > 20) || (!!hasCheckbox && textLen > 10);
      if (hasRealContent && rendersTall) return el;
    }
    return null;
  }

  // Returns true only if the bundle widget actually contains a real offer
  // (a product link / price), not just an empty app shell. Verticals without a
  // roll-out bundle render an empty .rbr-desktop; we must NOT reserve space for it.
  function rebuyHasContent() {
    return !!findRealRebuy();
  }

  function applyRebuyState() {
    var allRebuys = document.querySelectorAll('.rbr-desktop');
    if (allRebuys.length === 0) return false;
    var realRebuy = findRealRebuy();

    if (realRebuy) {
      // Real bundle present. Move it into the wrap and reveal it.
      moveRebuyIntoWrap();
      document.documentElement.classList.add('syn-rbr-ready');
      realRebuy.style.setProperty('opacity', '1', 'important');
      realRebuy.style.setProperty('max-height', 'none', 'important');
      realRebuy.style.setProperty('overflow', 'visible', 'important');
      realRebuy.style.removeProperty('display');

      // Collapse any other (empty shell) .rbr-desktop elements to zero space
      // so they can't reserve height or intercept clicks. Do not use
      // display:none so the app can still fill them later if it wants to.
      allRebuys.forEach(function(el) {
        if (el !== realRebuy) {
          el.style.setProperty('opacity', '0', 'important');
          el.style.setProperty('max-height', '0', 'important');
          el.style.setProperty('overflow', 'hidden', 'important');
        }
      });
      return true;
    } else {
      // No real bundle exists on this product (all .rbr-desktop are empty
      // shells). Collapse all of them so they don't leave a phantom gap.
      allRebuys.forEach(function(el) {
        el.style.setProperty('opacity', '0', 'important');
        el.style.setProperty('max-height', '0', 'important');
        el.style.setProperty('overflow', 'hidden', 'important');
        el.style.removeProperty('display');
      });
      return false;
    }
  }

  function initRebuy() {
    // Decide reveal vs collapse based on whether the widget has real content.
    applyRebuyState();

    // The app may inject the bundle late; re-evaluate when the DOM changes.
    var observer = new MutationObserver(function() {
      applyRebuyState();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function() { observer.disconnect(); }, 12000);

    // Poll a few times as a backup, then settle.
    var checkCount = 0;
    var interval = setInterval(function() {
      checkCount++;
      applyRebuyState();
      if (checkCount > 24) clearInterval(interval);
    }, 500);
  }

  function initAccessories() {
    var selleasy = document.querySelector('.lb-upsell-ppa-card-cont');
    if (selleasy && !document.getElementById('syn-acc-header')) {
      var accItems = selleasy.querySelectorAll('.lb-upsell-product-page-card');
      var accCount = accItems.length || 6;
      var accHeader = document.createElement('div');
      accHeader.className = 'syn-collapse-header';
      accHeader.id = 'syn-acc-header';
      accHeader.innerHTML = '<div class="syn-collapse-left"><span class="syn-collapse-title">Pick Your Accessories</span></div><span class="syn-collapse-btn" id="syn-acc-btn">Show ' + accCount + ' items &#9662;</span>';
      selleasy.parentElement.insertBefore(accHeader, selleasy);
      accHeader.addEventListener('click', function() {
        var btn = document.getElementById('syn-acc-btn');
        if (selleasy.classList.contains('syn-open')) {
          selleasy.classList.remove('syn-open');
          btn.innerHTML = 'Show ' + accCount + ' items &#9662;';
        } else {
          selleasy.classList.add('syn-open');
          btn.innerHTML = 'Hide &#9652;';
        }
      });
    }
    if (!selleasy) {
      if (!window.synAccRetry) window.synAccRetry = 0;
      if (window.synAccRetry < 60) { window.synAccRetry++; setTimeout(initAccessories, 150); }
    }
  }

  function initTabs() {
    var btns = document.querySelectorAll('.syn-tab-btn');
    btns.forEach(function(btn) {
      if (btn.dataset.synBound) return;
      btn.dataset.synBound = 'true';
      btn.addEventListener('click', function() {
        var tab = btn.getAttribute('data-syntab');
        var tabsWrap = btn.closest('.syn-tabs');
        var allBtns = tabsWrap.querySelectorAll('.syn-tab-btn');
        var allPanels = tabsWrap.querySelectorAll('.syn-tab-panel');
        allBtns.forEach(function(b) { b.classList.remove('syn-tab-active'); });
        btn.classList.add('syn-tab-active');
        allPanels.forEach(function(p) { p.classList.remove('syn-tab-visible'); });
        tabsWrap.querySelector('[data-synpanel="' + tab + '"]').classList.add('syn-tab-visible');
      });
    });
  }

  function boot() {
    /* v2.22: the two element moves run immediately with per-frame retries
       (their old fixed delays - 800ms for the badges - were the visible
       "glitch in and out" Chris reported once the speed pass made the page
       paint early enough to expose them). */
    moveTrustStripBeforeVariants();
    moveElements();

    /* v2.24: Chris - "Pick your rack / Pick your color / Add dumbbells /
       Add accessories all come in one after another delayed." The picker
       styling waited on 500ms timers with 300ms polls, and the accessories
       header was bolted on up to 1.5s AFTER its widget appeared, adding a
       second pop. One shared observer now reacts the instant each piece
       lands in the DOM; the old timers stay only as a backstop. The Rebuy
       and SellEasy widgets themselves still arrive on their apps' network
       timing - that part is theirs - but the kit no longer adds a single
       millisecond on top, and every arrival fades in instead of jolting. */
    var kicked = { pills: false, acc: false };
    function kick() {
      var rio = document.querySelector('.rio-options');
      if (rio && !kicked.pills) {
        kicked.pills = true;
        styleRackButtons();
        buildPills();
        initVariantNotes();
      }
      if (!kicked.acc && document.querySelector('.lb-upsell-ppa-card-cont')) {
        kicked.acc = true;
        initAccessories();
      }
    }
    kick();
    if ('MutationObserver' in window && (!kicked.pills || !kicked.acc)) {
      var pending = false;
      var mo = new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; kick(); });
      });
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 15000);
    }
    setTimeout(styleRackButtons, 800);
    setTimeout(buildPills, 800);
    setTimeout(initVariantNotes, 1200);
    setTimeout(initRebuy, 0);
    setTimeout(initAccessories, 1500);
    setTimeout(initTabs, 100);
    setTimeout(initTabs, 1000);
    initChatShift();
  }

  // Toggle a body class when the Impulse sticky Add to Cart bar is visible on mobile.
  // The chat widget (Shopify Inbox) gets pushed up via CSS only when this class is present.
  function initChatShift() {
    if (!window.matchMedia('(max-width: 768px)').matches) return;

    var lastState = null;
    var trigger = document.querySelector('product-form, [data-product-form], .product-form, .product__buy-buttons');

    // Core check function that measures whether buy buttons are past the chat-icon zone
    var checkPosition = function() {
      var shouldShift = false;
      if (trigger) {
        var rect = trigger.getBoundingClientRect();
        // Fire when the bottom of the buy buttons crosses ~60% of viewport height.
        // This matches when Impulse's sticky cart bar typically appears, eliminating perceived lag.
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        shouldShift = rect.bottom < (viewportHeight * 0.6);
      } else {
        // Fallback: scroll position based
        shouldShift = window.scrollY > 600;
      }
      // Only update DOM if state changed (avoids thrashing)
      if (shouldShift !== lastState) {
        lastState = shouldShift;
        document.body.classList.toggle('syn-cart-bar-visible', shouldShift);
      }
    };

    // Run immediately on init
    checkPosition();

    // Re-run on scroll (passive, throttled via requestAnimationFrame)
    var scrollPending = false;
    window.addEventListener('scroll', function() {
      if (!scrollPending) {
        scrollPending = true;
        requestAnimationFrame(function() {
          checkPosition();
          scrollPending = false;
        });
      }
    }, { passive: true });

    // Re-run on resize (orientation change, etc.)
    window.addEventListener('resize', checkPosition, { passive: true });

    // Re-run when Shopify Inbox iframe appears (it loads asynchronously after page load)
    if ('MutationObserver' in window) {
      var bodyObserver = new MutationObserver(function() {
        // If chat iframe just appeared, re-evaluate position
        var chatExists = document.querySelector('#ShopifyChat, #shopify-chat, iframe[name="ShopifyChat"], iframe[id^="ShopifyChat"], [id^="shopify-chat"]');
        if (chatExists) {
          checkPosition();
        }
      });
      bodyObserver.observe(document.body, { childList: true, subtree: false });

      // Stop watching after 15 seconds. Chat should have loaded by then.
      setTimeout(function() { bodyObserver.disconnect(); }, 15000);
    }

    // Also re-check at intervals for the first few seconds in case chat loads late
    [500, 1500, 3000, 6000].forEach(function(delay) {
      setTimeout(checkPosition, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

function synToggleDumbbells(header) {
  var wrap = document.querySelector('.syn-rebuy-wrap');
  var btnText = header.querySelector('.syn-collapse-btn-text');
  var isOpen = header.classList.contains('syn-open');
  if (isOpen) {
    header.classList.remove('syn-open');
    wrap.classList.remove('syn-open');
    wrap.style.display = 'none';
    btnText.textContent = 'Show 1 item';
  } else {
    header.classList.add('syn-open');
    wrap.classList.add('syn-open');
    wrap.style.display = 'block';
    btnText.textContent = 'Hide';
  }
}

;

(function () {
  var VIDS = {
    'delta-10-tier-vertical-dumbbell-storage-rack': [
      { id: 'IfOTpiEDcxA', t: '', img: 'https://cdn.shopify.com/s/files/1/0769/3651/1807/files/hqdefault.jpg?v=1786582346' }
    ],
    'delta-pk-vertical-hybrid-plate-and-kettlebell-storage-rack': [
      { id: '9SkVQR5z9hQ', t: '', img: 'https://cdn.shopify.com/s/files/1/0769/3651/1807/files/hqdefault_1a2848fd-2b8d-4327-8c94-98cca002bff6.jpg?v=1786584046' },
      { id: 'H9Pb1GhohPc', t: '', img: 'https://cdn.shopify.com/s/files/1/0769/3651/1807/files/hqdefault_e7b0dcfc-dfa4-42ca-8f2b-980f7eb442b0.jpg?v=1786584046' },
      { id: 'CFkjHPkTm70', t: '', img: 'https://cdn.shopify.com/s/files/1/0769/3651/1807/files/hqdefault_ef2e9b34-8909-48ce-b0aa-a2b88b031709.jpg?v=1786584046' },
      { id: 't3kIphzCt80', t: '', img: 'https://cdn.shopify.com/s/files/1/0769/3651/1807/files/hqdefault_fb90d8af-27bf-46ac-b237-e909ddabb6f0.jpg?v=1786584046' }
    ],
    'delta-adjustable-dumbbell-rack': [
      { id: '6csK30U0oNo', t: '', img: 'https://cdn.shopify.com/s/files/1/0769/3651/1807/files/hqdefault_bd4a810f-4ebe-43be-ab56-456c879718d2.jpg?v=1786584046' }
    ],
    'delta-5-tier-horizontal-rack': [
      { id: 'MfR4tgOBUko', t: '', img: 'https://cdn.shopify.com/s/files/1/0769/3651/1807/files/hqdefault_4d0a6e20-f6d4-43c8-8a74-cca021ab75ab.jpg?v=1786584046' },
      { id: 'ZGzK_U3kUAk', t: '', img: 'https://cdn.shopify.com/s/files/1/0769/3651/1807/files/hqdefault_60860786-2fe7-4d6d-b022-d8c557e51d9b.jpg?v=1786582346' },
      { id: 'g_Zj7dRTEC0', t: '', img: 'https://cdn.shopify.com/s/files/1/0769/3651/1807/files/hqdefault_326a163d-e1c5-4f75-95f8-dd6d60ddaa78.jpg?v=1786584046' }
    ],
    'delta-plt-vertical-plate-tree': [
      { id: 'CFkjHPkTm70', t: '', img: 'https://cdn.shopify.com/s/files/1/0769/3651/1807/files/hqdefault_ef2e9b34-8909-48ce-b0aa-a2b88b031709.jpg?v=1786584046' }
    ],
    '3-tier-horizontal-rack': [
      { id: 'N__4coMUWj0', t: '', img: 'https://cdn.shopify.com/s/files/1/0769/3651/1807/files/hqdefault_d4e373f0-870e-4efa-9132-4f094d991a20.jpg?v=1786582346' }
    ]
  };
  VIDS['delta-6-tier-horizontal-rack'] = VIDS['delta-5-tier-horizontal-rack'];

  function playSvg() { return '<span class="syn-vidrev-play"><svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg></span>'; }

  function buildBand(list) {
    var sec = document.createElement('section');
    sec.className = 'syn-vidrev';
    var cards = list.map(function (v, i) {
      var label = v.t ? '<span class="syn-vidrev-label">' + v.t + '</span>' : '';
      return '<button type="button" class="syn-vidrev-card" data-vid="' + v.id + '" style="background-image:url(' + v.img + ')" aria-label="Play independent review video">' + playSvg() + label + '</button>';
    }).join('');
    var gridClass = list.length === 4 ? 'syn-vidrev-grid syn-vidrev-grid--2x2' : 'syn-vidrev-grid';
    sec.innerHTML = '<div class="syn-vidrev-in"><p class="syn-vidrev-eyebrow">Independent reviews</p><h2 class="syn-vidrev-title">Don\'t Take Our Word For It</h2><p class="syn-vidrev-sub">Real reviews of this rack family from the garage gym community. Tap to watch, right here.</p><div class="' + gridClass + '">' + cards + '</div></div>';
    sec.addEventListener('click', function (e) {
      var card = e.target.closest('.syn-vidrev-card');
      if (!card || card.dataset.playing) return;
      card.dataset.playing = 'true';
      card.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + card.dataset.vid + '?autoplay=1&rel=0&modestbranding=1&playsinline=1" title="Independent review video" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
    });
    return sec;
  }

  function addVidRevChip(attempt) {
    attempt = attempt || 0;
    if (document.querySelector('.syn-vidrev-chip')) return;
    var after = document.querySelector('.syn-badges[data-syn-moved="true"]');
    var bb = document.querySelector('.product-form__buy-buttons:not(.product-sticky-form .product-form__buy-buttons)');
    var target = after || bb;
    if (!target) {
      if (attempt < 120) { requestAnimationFrame(function () { addVidRevChip(attempt + 1); }); }
      return;
    }
    var a = document.createElement('a');
    a.className = 'syn-vidrev-chip';
    a.setAttribute('role', 'button');
    a.setAttribute('tabindex', '0');
    a.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>Watch independent reviews';
    function go(e) { e.preventDefault(); var b = document.querySelector('.syn-vidrev'); if (b) b.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    a.addEventListener('click', go);
    a.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') go(e); });
    target.parentNode.insertBefore(a, target.nextSibling);
  }

  function firstNonStickyEl(selector) {
    var els = document.querySelectorAll(selector);
    for (var i = 0; i < els.length; i++) {
      if (!els[i].closest('.product-sticky-form')) return els[i];
    }
    return null;
  }

  function initVidRev(attempt) {
    attempt = attempt || 0;
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    var list = VIDS[m[1]];
    if (!list) return;
    if (document.querySelector('.syn-vidrev')) return;
    /* preferred: right below the specs and features tabs (Chris's call) */
    var tabs = document.querySelector('.syn-tabs');
    var host = tabs && tabs.closest('.shopify-section');
    if (host) {
      host.parentNode.insertBefore(buildBand(list), host.nextSibling);
      addVidRevChip();
      return;
    }
    /* fallback: directly after the main product section */
    var anchor = firstNonStickyEl('product-variants') || firstNonStickyEl('.product-form__variants') || firstNonStickyEl('.product-form');
    host = anchor && anchor.closest('.shopify-section');
    if (host) {
      host.parentNode.insertBefore(buildBand(list), host.nextSibling);
      addVidRevChip();
      return;
    }
    /* fallback: old position, just before the Judge.me review band */
    var jm = document.getElementById('judgeme_product_reviews');
    host = jm && jm.closest('.shopify-section');
    if (!host) {
      if (attempt < 300) { requestAnimationFrame(function () { initVidRev(attempt + 1); }); }
      return;
    }
    host.parentNode.insertBefore(buildBand(list), host);
    addVidRevChip();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initVidRev(); });
  } else {
    initVidRev();
  }

  /* v2.37: one-open FAQ accordion. The per-product blocks toggle their own
     item inline; this capture-phase listener runs first and closes every
     OTHER open item, so exactly one can be open at a time. */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.syn-faq-q');
    if (!q) return;
    var item = q.parentElement;
    var faq = q.closest('.syn-faq');
    if (!faq) return;
    var open = faq.querySelectorAll('.syn-faq-item.syn-faq-open');
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== item) open[i].classList.remove('syn-faq-open');
    }
  }, true);
})();

;

(function () {
  /* v2.48: lists MIRROR Chris's actual SellEasy per-product assignments,
     extracted from the live rendered widget on every mapped PDP (the
     app's JS loads from cdn.shopify.com, so it renders headless; raw
     capture in the session scratchpad, selleasy-lists.json). Pages
     where the app showed NO widget borrow their nearest sibling's list
     (charlie -> std verticals; 3-tier -> 2-tier; delta-5 -> delta-6;
     expansion kits -> 2-tier). Plate trees keep the kit-authored list -
     the app never had one for them. */
  var VERT_DB_STD = ['barbell-holder-vertical-mount-for-3x3-uprights', 'battle-rope-anchor', 'battle-rope-anchor-2x3-base', 'olympic-bar-landmine-3x3-upright-attachment', 'olympic-bar-landmine-2x3-base-attachment', 'weight-plate-storage-mount'];
  /* v2.81: wall and rack MOUNTS take no accessories. Everything in
     VERT_DB_STD bolts to a 3x3 upright or a 2x3 base, and a mount has
     neither. An empty list is deliberate rather than dropping the handle
     from FAMILIES: initAccCarousel bails entirely on an unmapped handle,
     which would take the dumbbell upgrade tile with it. Empty array is
     truthy, so the function runs, finds no accessories to draw, and
     renders the tile alone. */
  var VERT_MOUNT_NOACC = [];
  var PK_KB_LIST = ['kettlebell-shelf-rubber-liner', 'battle-rope-anchor-2x3-base', 'olympic-bar-landmine-2x3-base-attachment', 'barbell-holder-with-horizontal-mount-for-2x3-base'];
  var ADJ_LIST = ['battle-rope-anchor-2x3-base', 'olympic-bar-landmine-2x3-base-attachment', 'barbell-holder-with-horizontal-mount-for-2x3-base', 'battle-rope-anchor', 'weight-plate-storage-mount', 'kettlebell-shelf', 'kettlebell-shelf-rubber-liner'];
  var VERT_PLT = ['plate-holder-extender-for-3x3-upright', 'battle-rope-anchor', 'olympic-bar-landmine-3x3-upright-attachment', 'barbell-holder-vertical-mount-for-3x3-uprights', 'resistance-bands'];
  var HORIZ_FULL = ['horizontal-shelf-for-dumbbells', 'flat-shelf-add-on-for-kettlebells-and-dumbbells', 'flat-shelf-rubber-liner', 'kettlebell-shelf', 'battle-rope-anchor', 'battle-rope-anchor-2x3-base', 'weight-plate-storage-mount', 'barbell-holder-vertical-mount-for-3x3-uprights', 'barbell-holder-with-horizontal-mount-for-2x3-base', 'olympic-bar-landmine-2x3-base-attachment', 'olympic-bar-landmine-3x3-upright-attachment'];
  var HORIZ_A4 = ['flat-shelf-add-on-for-kettlebells-and-dumbbells', 'flat-shelf-rubber-liner', 'kettlebell-shelf', 'battle-rope-anchor', 'battle-rope-anchor-2x3-base', 'weight-plate-storage-mount', 'barbell-holder-vertical-mount-for-3x3-uprights', 'barbell-holder-with-horizontal-mount-for-2x3-base', 'olympic-bar-landmine-2x3-base-attachment', 'olympic-bar-landmine-3x3-upright-attachment'];
  var HORIZ_D6 = HORIZ_FULL.concat(['double-post-kettlebell-shelf']);
  /* v2.44: each family gets ONE premium-upgrade tile above the
     accessories carousel, replacing the matching app module. Chris:
     "the roll out [needs] its own tile since its a premium upgrade.
     same for the dumbbells." */
  var UPGRADES = {
    horiz: { handle: 'horizontal-roll-out-add-on', title: 'Roll-Out Shelf Add-on', desc: 'Converts the bottom tier into a roll-out shelf.', cls: 'syn-rollout-native' },
    /* v2.45: Chris - the dumbbells tile sells the SETS product, shown
       even while sold out (allowSoldOut renders a disabled Sold Out
       button per variant instead of skipping the tile) */
    vert: { handle: 'prx-rubber-hex-dumbbells-sets', title: 'PRx Rubber Hex Dumbbell Sets', desc: 'Complete sets from light to heavy.', cls: 'syn-dumbbells-native', allowSoldOut: true }
  };
  /* v2.81: a page whose capacity has an EXACT set gets that set instead
     of the three-variant sets product. Keyed by product handle, checked
     before the family default. Only add a handle here when the set
     genuinely matches the rack: the whole point is that a shopper cannot
     buy ten pairs for eight tiers. */
  /* v2.82: `variantSku` narrows a multi-variant set product down to the
     one set that fits this rack. Match on SKU rather than variant id so
     the mapping stays readable and survives a variant being rebuilt. */
  var A8_SET = { handle: '5-40lb-prx-rubber-hex-dumbbell-set', title: '5-40 lb PRx Rubber Hex Dumbbell Set', desc: 'Eight pairs, 5 to 40 lb. Fills every tier.', cls: 'syn-dumbbells-native', allowSoldOut: true };
  var D10_SET = { handle: 'prx-rubber-hex-dumbbells-sets', variantSku: 'PXB320', title: '5-50 lb PRx Rubber Hex Dumbbell Set', desc: 'Ten pairs, 5 to 50 lb. Fills every tier.', cls: 'syn-dumbbells-native', allowSoldOut: true,
    /* v2.85: same ten pairs, two handle styles. options[0] is the set
       above; options[1] is a second product. Shown only when options[1]
       actually loads, otherwise the tile is exactly the one-set tile. */
    choice: {
      title: '5-50 lb PRx Dumbbell Set',
      aria: 'Handle style',
      options: [
        { label: 'Ergonomic', icon: 'arc', desc: 'Ten pairs, 5 to 50 lb. Slightly arched, knurled chrome handles.' },
        { handle: 'prx-straight-handle-dumbbell-set', label: 'Straight', icon: 'bar', desc: 'Ten pairs, 5 to 50 lb. Straight, fully knurled chrome handles.' }
      ]
    }
  };
  /* Chris: "add heavy for alpha elite". PXB322 is out of stock today and
     allowSoldOut keeps the tile up with a Notify Me button, which is the
     point - the pairing is right even when the stock is not. */
  var AE_SET = { handle: 'prx-rubber-hex-dumbbells-sets', variantSku: 'PXB322', title: '55-100 lb PRx Rubber Hex Dumbbell Set', desc: 'The heavy pairs the Elite frame is built for.', cls: 'syn-dumbbells-native', allowSoldOut: true };
  var UPGRADE_BY_HANDLE = {
    'alpha-8-tier-vertical-dumbbell-storage-rack': A8_SET,
    'alpha-8-tier-vertical-dumbbell-storage-mount': A8_SET,
    'delta-10-tier-vertical-dumbbell-storage-rack': D10_SET,
    'delta-10-tier-vertical-dumbbell-storage-mount': D10_SET,
    'alpha-elite-5-tier-vertical-dumbbell-storage-rack': AE_SET,
    'alpha-elite-5-tier-vertical-dumbbell-storage-mount': AE_SET
  };
  var FAMILIES = {
    'delta-10-tier-vertical-dumbbell-storage-rack': VERT_DB_STD,
    'alpha-8-tier-vertical-dumbbell-storage-rack': VERT_DB_STD,
    'bravo-5-tier-vertical-dumbbell-storage-rack': VERT_DB_STD,
    'alpha-elite-5-tier-vertical-dumbbell-storage-rack': VERT_DB_STD,
    'delta-elite-8-tier-vertical-dumbbell-storage-rack': VERT_DB_STD,
    'charlie-5-tier-small-vertical-dumbbell-storage-rack-dbrk5s': VERT_DB_STD,
    'delta-pk-vertical-hybrid-plate-and-kettlebell-storage-rack': PK_KB_LIST,
    'alpha-pk-vertical-hybrid-plate-and-kettlebell-storage-rack': PK_KB_LIST,
    'delta-plt-vertical-plate-tree': VERT_PLT,
    'vertical-plate-storage-rack': VERT_PLT,
    'alpha-kb-vertical-kettlebell-storage-rack': PK_KB_LIST,
    'alpha-adjustable-dumbbell-rack': ADJ_LIST,
    'bravo-adjustable-dumbbell-rack': ADJ_LIST,
    'delta-adjustable-dumbbell-rack': ADJ_LIST,
    '2-tier-horizontal-rack': HORIZ_FULL,
    '3-tier-horizontal-rack': HORIZ_FULL,
    'alpha-4-tier-horizontal-rack': HORIZ_A4,
    'delta-5-tier-horizontal-rack': HORIZ_D6,
    'delta-6-tier-horizontal-rack': HORIZ_D6,
    'vertical-to-horizontal-rack-expansion-kit': HORIZ_FULL,
    'bravo-vertical-to-horizontal-rack-expansion-kit': HORIZ_FULL,
    'delta-vertical-to-horizontal-rack-expansion-kit': HORIZ_FULL
  };

  /* v2.66: coverage extended from the 21 racks to the WHOLE catalog.
     Rack-adjacent hardware (single uprights and stands, wall mounts,
     storage add-ons, roll-out kits, bundles) inherits the matching
     rack list; every other accessory cross-sells its companions; and
     free weights get a STORAGE strip instead - the rack or mount that
     holds that exact kind of weight. Gift card and calculator are
     deliberately excluded. The current product is always filtered out
     of its own strip. */
  var ACC_CROSS = ['battle-rope-anchor', 'olympic-bar-landmine-3x3-upright-attachment', 'barbell-holder-vertical-mount-for-3x3-uprights', 'weight-plate-storage-mount', 'kettlebell-shelf', 'flat-shelf-add-on-for-kettlebells-and-dumbbells', 'resistance-bands'];
  var STORE_DB = ['delta-10-tier-vertical-dumbbell-storage-rack', 'alpha-8-tier-vertical-dumbbell-storage-rack', 'alpha-elite-5-tier-vertical-dumbbell-storage-rack', 'delta-elite-8-tier-vertical-dumbbell-storage-rack', 'bravo-5-tier-vertical-dumbbell-storage-rack', 'delta-adjustable-dumbbell-rack'];
  var STORE_KB = ['alpha-kb-vertical-kettlebell-storage-rack', 'delta-pk-vertical-hybrid-plate-and-kettlebell-storage-rack', 'kettlebell-shelf', 'double-post-kettlebell-shelf', 'flat-shelf-add-on-for-kettlebells-and-dumbbells'];
  var STORE_PLATE = ['delta-plt-vertical-plate-tree', 'vertical-plate-storage-rack', 'weight-plate-storage-mount', 'plate-holder-extender-for-3x3-upright', 'delta-pk-vertical-hybrid-plate-and-kettlebell-storage-rack'];
  var STORE_BAR = ['barbell-holder-vertical-mount-for-3x3-uprights', 'barbell-holder-with-horizontal-mount-for-2x3-base', 'olympic-bar-landmine-3x3-upright-attachment', 'olympic-bar-landmine-2x3-base-attachment'];
  var STORE_ROPE = ['battle-rope-anchor', 'battle-rope-anchor-2x3-base'];
  var STORE_BALL = ['flat-shelf-add-on-for-kettlebells-and-dumbbells', 'kettlebell-shelf', 'multi-use-shelf-and-wall-mount-accessory-hanger', 'double-post-kettlebell-shelf'];
  var STORAGE = {
    /* v2.77: the 20 PRx-VENDOR handles used to sit here, added by v2.66
       when free weights got a "Store Them" strip. Chris: "on the prx
       items you added accessories. please remove them." These are resale
       goods that ship direct from PRx outside our free-shipping promo,
       and a Synergy storage strip on them is our merchandising on
       somebody else's product page. Removed by VENDOR, not by handle
       prefix: cast-iron-change-plates and cast-iron-olympic-plates are
       PRx Performance too and a prx- prefix match would have missed both.
       The Synergy-vendored entries below stay. DO NOT RE-ADD by prefix. */
    '3-in-1-wooden-plyo-box-20x24x30': STORE_BALL,
    'olympic-bar-landmine-3x3-upright-attachment': STORE_BAR,
    'olympic-bar-landmine-2x3-base-attachment': STORE_BAR,
    'barbell-holder-with-horizontal-mount-for-2x3-base': STORE_BAR,
    'barbell-holder-vertical-mount-for-3x3-uprights': STORE_BAR,
    'color-bumper-plates': STORE_PLATE
  };
  var EXTRA_FAMILIES = {
    'battle-rope-anchor': ACC_CROSS,
    'battle-rope-anchor-2x3-base': ACC_CROSS,
    'plate-holder-extender-for-3x3-upright': ACC_CROSS,
    'alpha-4-tier-horizontal-rack-double-post': HORIZ_FULL,
    'delta-vertical-dumbbell-storage-add-on-for-horizontal-rack': HORIZ_FULL,
    'alpha-vertical-dumbbell-storage-add-on-for-horizontal-rack': HORIZ_FULL,
    'bravo-vertical-dumbbell-storage-add-on-for-horizontal-rack': HORIZ_FULL,
    'delta-10-tier-vertical-dumbbell-storage-mount': VERT_MOUNT_NOACC,
    /* v2.76: the five ACTIVE bundle handles used to sit here, added by
       v2.66 when coverage went catalog-wide. Chris, twice: "dont touch
       the bundles" and then "the bundles all have the dumbbell and
       accessories upsells, you have to remove it." A bundle is already
       a curated multi-product purchase, so a strip telling the buyer to
       add more is working against the page. Removed outright rather
       than special-cased, which also takes the accessory carousel with
       it. DO NOT RE-ADD:
         delta-10-tier-vertical-dumbbell-rack-bundle-with-accessories
         delta-vertical-storage-bundle-for-dumbbells-plates-and-kettlebells
         delta-10-tier-and-alpha-elite-5-tier-5-100-lb-set-bundle
         alpha-8-tier-vertical-dumbbell-rack-5-40-lb-set-bundle
         delta-10-tier-vertical-dumbbell-rack-5-50-lb-set-bundle */
    'bravo-5-tier-vertical-dumbbell-storage-mount': VERT_MOUNT_NOACC,
    /* v2.82, Chris "go": no accessories on ANY of the five mounts */
    'alpha-8-tier-vertical-dumbbell-storage-mount': VERT_MOUNT_NOACC,
    'alpha-elite-5-tier-vertical-dumbbell-storage-mount': VERT_MOUNT_NOACC,
    'delta-elite-8-tier-vertical-dumbbell-storage-mount': VERT_MOUNT_NOACC,
    'delta-single-stand': VERT_DB_STD,
    'alpha-single-stand': VERT_DB_STD,
    'bravo-single-stand': VERT_DB_STD,
    'delta-single-upright-3x3': VERT_DB_STD,
    'alpha-single-upright-3x3': VERT_DB_STD,
    'bravo-single-upright-3x3': VERT_DB_STD,
    'horizontal-roll-out-add-on': HORIZ_FULL,
    'horizontal-roll-out-upgrade-kit': HORIZ_FULL,
    'horizontal-roll-out-shelf': HORIZ_FULL,
    'adjustable-dumbbell-storage-arms': VERT_DB_STD,
    'double-post-kettlebell-shelf': ACC_CROSS,
    'kettlebell-shelf-rubber-liner': ACC_CROSS,
    'flat-shelf-rubber-liner': ACC_CROSS,
    'horizontal-shelf-for-dumbbells': HORIZ_FULL,
    'kettlebell-shelf': ACC_CROSS,
    'weight-plate-storage-mount': ACC_CROSS,
    'multi-use-shelf-and-wall-mount-accessory-hanger': ACC_CROSS,
    'multi-use-wall-mounted-accessory-hanger': ACC_CROSS,
    'resistance-bands': ACC_CROSS,
    'flat-shelf-add-on-for-kettlebells-and-dumbbells': ACC_CROSS
  };

  /* v2.88: Chris: "i imported two more products from ancore. can u make the
     product pages for those and find a way to upsell each within each others
     product pages." ANCORE Pro, Resistance Plates and Plate Dock offer ONLY each
     other, never Synergy hardware (same rule as v2.77 for PRx: no Synergy
     merchandising on a resale page), and Synergy pages do not offer ANCORE.
     Order is per page: the Pro leads with plates (the add-on that changes its
     range), the plates lead with the Pro (they do nothing without one), the
     dock leads with the plates it holds. Each is fetched like any other card,
     so a product that is still DRAFT simply 404s and its card is not drawn;
     this can publish before the products do. Not in UPGRADE_OK (that is
     snapshotted from FAMILIES before this merges), so no upgrade tile. */
  var ANCORE_FAMILY = {
    'ancore-pro': ['resistance-plates', 'plate-dock'],
    'resistance-plates': ['ancore-pro', 'plate-dock'],
    'plate-dock': ['resistance-plates', 'ancore-pro']
  };
  /* strip heading per page; anything not listed keeps 'Pick Your Accessories' */
  var STRIP_LABEL = {
    'ancore-pro': 'Complete Your Setup',
    'resistance-plates': 'Complete Your Setup',
    'plate-dock': 'Complete Your Setup'
  };
  /* pages whose strip must NOT carry the free-shipping meter. ANCORE ships
     direct at ANCORE's own rate and never counts toward $249 (synShipSubtotal
     skips the vendor), so a meter on these pages could only ever describe the
     OTHER items in the cart, which reads as if ANCORE could earn it. */
  var NO_SHIP_METER = { 'ancore-pro': 1, 'resistance-plates': 1, 'plate-dock': 1 };
  Object.keys(ANCORE_FAMILY).forEach(function (k) { EXTRA_FAMILIES[k] = ANCORE_FAMILY[k]; });

  /* the upgrade tile stays scoped to the 21 core racks - a dumbbell-set
     tile on a single upright or a bumper-plate page would be noise */
  var UPGRADE_OK = {};
  Object.keys(FAMILIES).forEach(function (k) { UPGRADE_OK[k] = true; });
  /* v2.67: ...but the roll-out tile belongs on EVERY horizontal page,
     including the ones v2.66 parked in EXTRA_FAMILIES. The double-post
     4-tier is a full rack; the three vertical add-ons and the tier set
     bolt onto a horizontal rack the buyer already owns. All of them can
     take a roll-out bottom tier, so all of them get the tile. This list
     is deliberately explicit rather than "everything in EXTRA_FAMILIES"
     - that would put a dumbbell-set tile on bumper plates and barbells,
     which is the noise v2.66 was avoiding. */
  ['alpha-4-tier-horizontal-rack-double-post',
   'delta-vertical-dumbbell-storage-add-on-for-horizontal-rack',
   'alpha-vertical-dumbbell-storage-add-on-for-horizontal-rack',
   'bravo-vertical-dumbbell-storage-add-on-for-horizontal-rack',
   'horizontal-shelf-for-dumbbells'].forEach(function (k) { UPGRADE_OK[k] = true; });
  /* v2.75: and the dumbbell tile belongs on the WALL AND RACK MOUNTS.
     They store a dumbbell set, ship with none, and are the same buyer
     as the floor racks - they were only ever missing it because
     UPGRADE_OK is snapshotted before EXTRA_FAMILIES merges in and the
     v2.67 fix for that only re-added horizontal handles.
     BUNDLES ARE DELIBERATELY NOT HERE. Chris, after seeing v2.75's
     first cut: "remove the accessories upsell you added to the bundles.
     dont touch the bundles." Bundle pages keep exactly the modules they
     have today. Single uprights and stands stay out too (v2.66 ruled
     them noise), as do the adjustable-dumbbell storage arms, whose
     buyer owns adjustables rather than hex sets. */
  ['delta-10-tier-vertical-dumbbell-storage-mount',
   'bravo-5-tier-vertical-dumbbell-storage-mount',
   'alpha-8-tier-vertical-dumbbell-storage-mount',
   'alpha-elite-5-tier-vertical-dumbbell-storage-mount',
   'delta-elite-8-tier-vertical-dumbbell-storage-mount'].forEach(function (k) { UPGRADE_OK[k] = true; });
  /* v2.82, Chris: "dont add any for bravo or delta elite". Applied LAST
     so it beats every list above that added these handles. Charlie is
     deliberately not here - he did not name it, see the changelog. */
  ['bravo-5-tier-vertical-dumbbell-storage-rack',
   'bravo-5-tier-vertical-dumbbell-storage-mount',
   'delta-elite-8-tier-vertical-dumbbell-storage-rack',
   'delta-elite-8-tier-vertical-dumbbell-storage-mount'].forEach(function (k) { delete UPGRADE_OK[k]; });
  /* the roll-out family must never be offered a roll-out: the add-on
     page would literally sell itself, and the other two are the same
     upgrade at a different price */
  var UPGRADE_SELF = {
    'horizontal-roll-out-add-on': 1,
    'horizontal-roll-out-upgrade-kit': 1,
    'horizontal-roll-out-shelf': 1
  };
  Object.keys(EXTRA_FAMILIES).forEach(function (k) { FAMILIES[k] = EXTRA_FAMILIES[k]; });

  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }

  /* v2.66: card names. Accessories read "Battle Rope Anchor | For 3x3
     Upright", so the part before the pipe is the name. Racks read
     "Delta | 10-Tier Vertical Dumbbell Storage Rack", where that same
     rule would leave a card labelled just "Delta" - so when the first
     segment is a bare family word, keep the segment after it too. */
  function shortName(title) {
    var parts = (title || '').split('|').map(function (s) { return s.trim(); });
    var name = parts[0];
    if (parts.length > 1 && parts[0].split(/\s+/).length <= 2) name = parts[0] + ' ' + parts[1];
    var spec = (title || '').match(/\b[23]x3\b/);
    if (spec && name.indexOf(spec[0]) === -1) name += ' (' + spec[0] + ')';
    return name;
  }

  function normImg(u, w) {
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u.split('?')[0] + '?width=' + (w || 360);
  }

  /* v2.64: swap an image with a crossfade. The outgoing frame is
     cloned over its own tile and faded out once the new src has
     painted, so a colour change reads as a dissolve rather than a
     flick. Falls back to a plain swap under prefers-reduced-motion. */
  function fadeSwap(img, host, newSrc) {
    if (!img || !newSrc) return;
    var cur = img.currentSrc || img.src || '';
    if (cur.split('?')[0] === newSrc.split('?')[0]) return;
    if (!host || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      img.src = newSrc;
      return;
    }
    var old = host.querySelector('.syn-imgghost');
    if (old && old.parentNode) old.parentNode.removeChild(old);
    var ghost = document.createElement('img');
    ghost.className = 'syn-imgghost';
    ghost.src = cur;
    ghost.setAttribute('aria-hidden', 'true');
    host.appendChild(ghost);
    img.src = newSrc;
    var finished = false;
    function done() {
      if (finished) return;
      finished = true;
      ghost.style.opacity = '0';
      setTimeout(function () { if (ghost.parentNode) ghost.parentNode.removeChild(ghost); }, 360);
    }
    if (img.complete && img.naturalWidth > 0) requestAnimationFrame(done);
    else { img.addEventListener('load', done, { once: true }); img.addEventListener('error', done, { once: true }); }
    setTimeout(done, 1400);
  }

  /* ===== v2.52: color-sync, free-shipping meter, quick-look ===== */
  /* v2.56: colors are read from each product's own Color option
     instead of a hardcoded list - the list said 'Pink' while the
     catalog says 'Hot Pink', so hot pink got no swatch and never
     color-synced (Chris). Nothing to maintain when colors change. */
  function colorIndex(p) {
    var opts = (p && p.options) || [];
    for (var i = 0; i < opts.length; i++) {
      var nm = (opts[i].name || opts[i] || '').toString();
      if (/colou?r/i.test(nm)) return i;
    }
    return -1;
  }
  function variantColor(p, v) {
    var idx = colorIndex(p);
    if (idx < 0) return null;
    if (v.options && v.options.length > idx) return String(v.options[idx]).trim();
    var segs = (v.title || '').split(' / ');
    return segs.length > idx ? segs[idx].trim() : null;
  }
  var rackP = null;
  /* v2.83: $249. See the changelog - this bar is hidden in production
     because it counts PRx lines that never ship free. */
  var FREE_SHIP_CENTS = 24900;

  var SHIP_TRUCK = '<svg viewBox="0 0 24 24"><path d="M1.5 5.5h12.5v10.5H1.5zM14 9.5h4.2l3.3 3.4V16H14z"/><circle cx="6" cy="18" r="1.8"/><circle cx="17.5" cy="18" r="1.8"/></svg>';
  var lastShipTotal = null;
  /* v2.54: brand-colored confetti when the cart crosses the free
     shipping line. Fires only on a live crossing, never on page load,
     and never under prefers-reduced-motion. */
  function synConfetti() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (document.getElementById('syn-confetti')) return;
    var cv = document.createElement('canvas');
    cv.id = 'syn-confetti';
    cv.style.cssText = 'position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:99999;';
    document.body.appendChild(cv);
    var ctx = cv.getContext('2d');
    var W = cv.width = window.innerWidth;
    var H = cv.height = window.innerHeight;
    var colors = ['#26B1FD', '#48c0ff', '#1fc16b', '#ffd23e', '#ff6b6b', '#17191c', '#ffffff'];
    var parts = [];
    for (var i = 0; i < 160; i++) {
      parts.push({
        x: Math.random() * W, y: -20 - Math.random() * H * 0.5,
        w: 5 + Math.random() * 6, h: 7 + Math.random() * 8,
        vy: 2 + Math.random() * 3.5, vx: -1.5 + Math.random() * 3,
        rot: Math.random() * Math.PI, vr: -0.12 + Math.random() * 0.24,
        c: colors[Math.floor(Math.random() * colors.length)]
      });
    }
    var start = null;
    function frame(ts) {
      if (!start) start = ts;
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < parts.length; i++) {
        var pt = parts[i];
        pt.x += pt.vx; pt.y += pt.vy; pt.vy += 0.05; pt.rot += pt.vr;
        ctx.save(); ctx.translate(pt.x, pt.y); ctx.rotate(pt.rot);
        ctx.fillStyle = pt.c; ctx.fillRect(-pt.w / 2, -pt.h / 2, pt.w, pt.h);
        ctx.restore();
      }
      if (ts - start < 3200) { requestAnimationFrame(frame); }
      else if (cv.parentNode) { cv.parentNode.removeChild(cv); }
    }
    requestAnimationFrame(frame);
  }
  /* v2.58: Chris prefers a plain, honest disclaimer over worst-case
     math (v2.57 measured the cart as if the advertised code were
     already applied, which made the bar move slower than the cart).
     The meter shows the real cart total; a small muted line states
     that the threshold applies after discounts, so a code entered at
     checkout can never come as a surprise. */
  /* v2.84: PRx is shipped under PRx's own policy and never ships free,
     so PRx lines cannot count toward our threshold. Same vendor test as
     assets/syn-freeship.js - a VENDOR check, not a handle list, because
     a handle snapshot rots the moment a product is added. */
  function synShipSubtotal(c) {
    var cents = 0;
    for (var i = 0; i < c.items.length; i++) {
      var it = c.items[i];
      /* 2026-10-05: ANCORE (Shopify Collective, ships direct with its own rate) added; it went live counting toward $249. */
      if (/prx|ancore/i.test(it.vendor || '') || it.handle === 'color-bumper-plates') continue;
      cents += (typeof it.final_line_price === 'number') ? it.final_line_price : (it.line_price || 0);
    }
    return cents;
  }

  function updateShip(c) {
    var el = document.querySelector('.syn-ship');
    if (!el || !c || !c.items) return;
    if (!c.item_count) { el.dataset.on = ''; lastShipTotal = 0; return; }
    var synCents = synShipSubtotal(c);
    /* nothing of ours in the cart: no threshold story to tell */
    if (synCents === 0) { el.dataset.on = ''; lastShipTotal = 0; return; }
    el.dataset.on = 'true';
    var text = el.querySelector('.syn-ship-text');
    var fill = el.querySelector('.syn-ship-fill');
    var truck = el.querySelector('.syn-ship-truck');
    var pct;
    if (synCents >= FREE_SHIP_CENTS) {
      el.dataset.free = 'true';
      text.textContent = 'Your order ships free';
      pct = 100;
      if (lastShipTotal !== null && lastShipTotal < FREE_SHIP_CENTS) synConfetti();
    } else {
      el.dataset.free = '';
      text.innerHTML = '<b>' + money(FREE_SHIP_CENTS - synCents) + '</b> away from free shipping';
      /* floor, so a 99.9% cart never shows a full bar next to copy that
         still asks for more */
      pct = Math.max(3, Math.min(99, Math.floor(synCents / FREE_SHIP_CENTS * 100)));
    }
    fill.style.width = pct + '%';
    if (truck) truck.style.left = pct + '%';
    lastShipTotal = synCents;
  }

  function refreshShip() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(updateShip).catch(function () {});
  }
  /* v2.53: the meter tracks the cart in real time (Chris removed items
     in the drawer and the line went stale). Every cart mutation on the
     page - the theme's own drawer removals included - goes through
     fetch to /cart/add|change|update|clear, so a thin wrapper refreshes
     the meter after any of them. Custom cart events are covered too. */
  (function () {
    if (window.synShipFetchPatched) return;
    window.synShipFetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function () {
      var p = origFetch.apply(this, arguments);
      try {
        var u = arguments[0];
        u = String(u && u.url ? u.url : u);
        if (/\/cart\/(add|change|update|clear)/.test(u)) {
          p.then(function () { setTimeout(refreshShip, 300); }, function () {});
        }
      } catch (e) {}
      return p;
    };
    ['cart:refresh', 'cart:updated', 'cart:change', 'cart:rerendered'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(refreshShip, 300); });
    });
  })();

  /* which color is the RACK currently in? Reads the buy form's live
     variant id against the rack's own product data. */
  /* v2.69: a tap on one of our own swatches states the rack colour
     outright, so remember it. Everything below this used to depend on
     deriving the colour from the selected variant id, and that chain
     has three ways to fail silently on a phone - see currentRackColor. */
  var lastSwatchColor = null, lastSwatchAt = 0;
  document.addEventListener('click', function (e) {
    var sw = (e.target && e.target.closest) ? e.target.closest('.syn-swatch') : null;
    if (sw && sw.dataset && sw.dataset.color) { lastSwatchColor = sw.dataset.color; lastSwatchAt = Date.now(); }
  }, true);

  /* v2.69: Chris reported colour sync dead on mobile for every product
     and every colour, label and photo alike, while desktop measured
     6/6 on all 12 colours. "Dead for everything" means the colour is
     never resolved at all, not that matching is wrong - and the old
     lookup had three independent ways to return null on a phone:
       1. rackP null. The rack's own product JSON is one of a batch of
          parallel fetches; if that single one loses a race on a mobile
          connection, colour sync is silently disabled for the session
          while the rest of the carousel looks perfectly normal.
       2. Only the FIRST [name="id"] was read. Themes commonly render a
          second add-to-cart form for the sticky mobile bar, so the
          first one on the page need not be the live picker.
       3. The URL fallback needs ?variant=, which is not always written.
     Now: check every add-to-cart form rather than just the first, fall
     back to the URL, and let a recent swatch tap outrank all of it -
     within the 4s resync burst the tap is the most reliable statement
     of intent there is, and it needs no product JSON, no form and no
     URL. Older taps stay as a last-resort fallback so a colour picked
     through the theme's own picker still wins later. */
  function currentRackColor() {
    var byVariant = null, i;
    function lookup(vid) {
      if (!vid || !rackP) return null;
      for (i = 0; i < rackP.variants.length; i++) {
        if (String(rackP.variants[i].id) === String(vid)) return variantColor(rackP, rackP.variants[i]);
      }
      return null;
    }
    var inputs = document.querySelectorAll('form[action*="/cart/add"] [name="id"]');
    for (var n = 0; n < inputs.length && !byVariant; n++) byVariant = lookup(inputs[n].value);
    if (!byVariant) { var mm = location.search.match(/[?&]variant=(\d+)/); if (mm) byVariant = lookup(mm[1]); }
    if (lastSwatchColor && (Date.now() - lastSwatchAt) < 6000) return lastSwatchColor;
    return byVariant || lastSwatchColor;
  }

  /* flip every accessory card to the rack's color where that color
     exists; cards without a match are left alone */
  function syncAccColor(color) {
    if (!color) return;
    var sels = document.querySelectorAll('.syn-acc-card .syn-acc-variant');
    for (var i = 0; i < sels.length; i++) {
      var s = sels[i], want = null;
      var target = color.toLowerCase();
      for (var k = 0; k < s.options.length; k++) {
        var t = s.options[k].textContent.trim().toLowerCase();
        if (t === target || t.split('/')[0].trim() === target) { want = s.options[k].value; break; }
      }
      if (want && s.value !== want) { s.value = want; s.dispatchEvent(new Event('change')); }
    }
  }

  /* ===== v2.71: width compatibility on horizontal racks =====
     Horizontal racks carry a "Width" option of 43" or 70". Three of the
     accessories on those pages carry "Choose Width" with 43" wide and
     70" wide: the Horizontal Tier Set Add-on, the Flat Shelf Add-on and
     the Flat Shelf Rubber Liner. A 70" shelf does not fit a 43" rack,
     so showing both widths on a rack page invites an order that has to
     come back. Chris asked that only the compatible width show, so the
     incompatible option is hidden outright rather than merely
     deselected - the custom dropdown skips hidden options and collapses
     to a static label when one remains. The two vocabularies differ
     ("43\"" vs "43\" wide"), so matching is on the leading number.
     Cards whose options are not widths are untouched, and if the rack
     width cannot be resolved nothing is hidden - failing open keeps
     every width buyable rather than hiding stock on a bad read. */
  function widthNum(t) { var m = String(t == null ? '' : t).match(/(\d+)\s*"/); return m ? m[1] : null; }

  function rackVariantObj() {
    if (!rackP || !rackP.variants) return null;
    var i, n, v = null;
    function find(vid) {
      if (!vid) return null;
      for (i = 0; i < rackP.variants.length; i++) {
        if (String(rackP.variants[i].id) === String(vid)) return rackP.variants[i];
      }
      return null;
    }
    var inputs = document.querySelectorAll('form[action*="/cart/add"] [name="id"]');
    for (n = 0; n < inputs.length && !v; n++) v = find(inputs[n].value);
    if (!v) { var mm = location.search.match(/[?&]variant=(\d+)/); if (mm) v = find(mm[1]); }
    return v;
  }

  function currentRackWidth() {
    var v = rackVariantObj();
    if (!v || !rackP.options) return null;
    for (var i = 0; i < rackP.options.length; i++) {
      var o = rackP.options[i];
      var name = (typeof o === 'string') ? o : (o && o.name);
      if (/width/i.test(name || '')) return widthNum(v['option' + (i + 1)]);
    }
    return null;
  }

  function syncAccWidth(w) {
    if (!w) return;
    var sels = document.querySelectorAll('.syn-acc-card .syn-acc-variant');
    for (var i = 0; i < sels.length; i++) {
      var s = sels[i], opts = s.options, isWidth = opts.length > 1, k, want = null;
      for (k = 0; k < opts.length && isWidth; k++) {
        if (!/^\s*\d+\s*"\s*wide\s*$/i.test(opts[k].textContent.trim())) isWidth = false;
      }
      if (!isWidth) continue;
      for (k = 0; k < opts.length; k++) {
        if (widthNum(opts[k].textContent) === w) { want = opts[k].value; opts[k].hidden = false; }
        else { opts[k].hidden = true; }
      }
      if (!want) { for (k = 0; k < opts.length; k++) opts[k].hidden = false; s.dataset.synW = ''; continue; }
      /* v2.72: only re-render when something ACTUALLY changed. v2.71
         dispatched unconditionally so the dropdown would redraw as a
         static label, but syncAccAll runs six times per resync burst
         (120ms to 4s), so one colour tap on a horizontal fired 28
         change events instead of 7 - each one re-rendering the card's
         price, label and dropdown. Harmless on a fast machine, visible
         flicker on a phone. dataset.synW remembers the width this
         select was last filtered to, so the redraw happens once. */
      var changed = (s.value !== want);
      if (changed) s.value = want;
      if (changed || s.dataset.synW !== w) { s.dataset.synW = w; s.dispatchEvent(new Event('change')); }
    }
  }

  function syncAccAll() { syncAccColor(currentRackColor()); syncAccWidth(currentRackWidth()); }

  /* v2.54: custom variant dropdown. The native select stays in the
     DOM, hidden, as the source of truth: this UI sets its value and
     dispatches change, and re-renders itself on any change event -
     so color-sync and every existing handler keep working untouched.
     The open list is appended to <body> with fixed positioning so it
     never clips inside the scroll strip or the transformed quick-look
     panel. */
  var DD_HEX = { 'black': '#17191c', 'synergy blue': '#26B1FD', 'white': '#f4f4f4', 'red': '#c8102e', 'grey': '#808285', 'gray': '#808285', 'orange': '#ff6a13', 'yellow': '#ffd100', 'blue': '#0057b8', 'military green': '#4b5320', 'military tan': '#b7a77a', 'hot pink': '#ff2d8a', 'pink': '#ff5c8a', 'purple': '#7d3f98' };
  var DD_CHEV = '<span class="syn-dd-chev"><svg viewBox="0 0 10 6"><path d="M1 1l4 4 4-4"/></svg></span>';
  function ddDot(t) {
    var key = t.split('/')[0].trim().toLowerCase();
    var hex = DD_HEX[key];
    return hex ? '<span class="syn-dd-dot" style="background:' + hex + '"></span>' : '';
  }
  function enhanceSelect(s) {
    if (s.dataset.synDd) return;
    s.dataset.synDd = 'true';
    var dd = document.createElement('div');
    dd.className = 'syn-dd';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'syn-dd-btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    dd.appendChild(btn);
    s.parentNode.insertBefore(dd, s.nextSibling);
    var list = null;
    function renderBtn() {
      var opt = s.options[s.selectedIndex];
      if (!opt) return;
      var t = opt.textContent.trim();
      /* v2.71: when width filtering leaves a single compatible option
         there is no choice left to offer, so render it as a plain
         label rather than a dropdown that opens onto one item. */
      var visible = 0;
      for (var v = 0; v < s.options.length; v++) if (!s.options[v].hidden) visible++;
      if (visible <= 1) dd.classList.add('syn-dd--static'); else dd.classList.remove('syn-dd--static');
      btn.innerHTML = ddDot(t) + '<span class="syn-dd-label">' + t + '</span>' + (visible <= 1 ? '' : DD_CHEV);
    }
    function closeList() {
      if (list && list.parentNode) list.parentNode.removeChild(list);
      list = null;
      document.removeEventListener('click', onDoc, true);
      document.removeEventListener('keydown', onKey, true);
      window.removeEventListener('scroll', onScroll, true);
      window.removeEventListener('resize', closeList);
    }
    /* v2.55: scrolling INSIDE the color list must not close it (Chris).
       The list is fixed-positioned, so it only needs to close when the
       page behind it moves - never on its own scroll. */
    function onScroll(e) {
      if (list && e.target && (e.target === list || (e.target.nodeType === 1 && list.contains(e.target)))) return;
      closeList();
    }
    function onDoc(e) { if (!dd.contains(e.target) && (!list || !list.contains(e.target))) closeList(); }
    function onKey(e) { if (e.key === 'Escape') closeList(); }
    function openList() {
      if (dd.classList.contains('syn-dd--static')) return;
      if (list) { closeList(); return; }
      list = document.createElement('div');
      list.className = 'syn-dd-list';
      list.setAttribute('role', 'listbox');
      for (var i = 0; i < s.options.length; i++) {
        if (s.options[i].hidden) continue;
        (function (opt) {
          var t = opt.textContent.trim();
          var item = document.createElement('button');
          item.type = 'button';
          item.className = 'syn-dd-item';
          item.setAttribute('role', 'option');
          item.dataset.sel = opt.value === s.value ? 'true' : '';
          item.innerHTML = ddDot(t) + '<span class="syn-dd-label">' + t + '</span>' + (opt.dataset.avail === '0' ? '<span class="syn-dd-note">Sold out</span>' : '');
          item.addEventListener('click', function () {
            closeList();
            if (s.value !== opt.value) {
              s.value = opt.value;
              s.dispatchEvent(new Event('change'));
            }
          });
          list.appendChild(item);
        })(s.options[i]);
      }
      var r = btn.getBoundingClientRect();
      list.style.left = Math.round(r.left) + 'px';
      list.style.top = Math.round(r.bottom + 6) + 'px';
      list.style.minWidth = Math.round(Math.max(r.width, 170)) + 'px';
      document.body.appendChild(list);
      /* flip above the button when there is no room below */
      var lr = list.getBoundingClientRect();
      if (lr.bottom > window.innerHeight - 8) {
        list.style.top = Math.round(Math.max(8, r.top - lr.height - 6)) + 'px';
      }
      document.addEventListener('click', onDoc, true);
      document.addEventListener('keydown', onKey, true);
      window.addEventListener('scroll', onScroll, true);
      window.addEventListener('resize', closeList);
    }
    btn.addEventListener('click', openList);
    s.addEventListener('change', renderBtn);
    renderBtn();
  }

  /* v2.59: hand-written quick-look blurbs. Chris: the auto-clipped
     description was not informative or persuasive enough. Each line
     answers the two questions that block an accessory purchase - what
     it does for me, and will it fit my rack - in one breath, grounded
     in the product's own description copy (fitment, capacity and
     hardware claims all come from the listings). Products without an
     entry fall back to briefDesc(). */
  var BLURBS = {
    'battle-rope-anchor': 'Bolts to any 3x3 upright so your battle rope has a fixed, stable anchor instead of a door or a post. Mounting hardware included.',
    'battle-rope-anchor-2x3-base': 'Anchors your battle rope to the 2x3 base leg, keeping the pull low and the rack planted. Mounting hardware included.',
    'olympic-bar-landmine-3x3-upright-attachment': 'Turns any 3x3 upright with 1 inch holes into a landmine station for rotational work, presses and rows. A built in magnet holds the bar in place between sets.',
    'olympic-bar-landmine-2x3-base-attachment': 'Mounts to the 2x3 base for landmine presses, rows and twists without a separate floor unit. A built in magnet parks the bar between sets.',
    'barbell-holder-vertical-mount-for-3x3-uprights': 'Stores Olympic bars upright and off the floor on any 3x3 upright with 1 inch holes. Steel build, hardware included.',
    'barbell-holder-with-horizontal-mount-for-2x3-base': 'Holds your Olympic bars on the 2x3 base tubing so they stay off the floor and out of the walkway. Steel build, hardware included.',
    'weight-plate-storage-mount': 'Gets Olympic plates off the floor and onto the rack, sorted by size and easy to grab mid set. Premium steel, built to stay put.',
    'plate-holder-extender-for-3x3-upright': 'An elbow attachment that rotates your plate holders 90 degrees to face forward, so the rack can sit flush against the wall and reclaim floor space.',
    'kettlebell-shelf': 'Holds 2 to 4 kettlebells on any 3x3 upright, clearing your floor without adding a second rack.',
    'kettlebell-shelf-rubber-liner': 'Drops into your kettlebell shelf to quiet the clang, grip the bells in place, and protect both the shelf and your gear.',
    'double-post-kettlebell-shelf': 'The wider kettlebell shelf built for double post horizontal racks, adding bell storage across the full span.',
    'flat-shelf-add-on-for-kettlebells-and-dumbbells': 'A flat tier for kettlebells, dumbbells and medicine balls, with two configurations and 800 lb capacity on the 43 inch, 1,000 lb on the 70 inch.',
    'flat-shelf-rubber-liner': 'Lines your flat shelf to cut noise, stop gear from sliding, and keep the powder coat looking new.',
    'horizontal-shelf-for-dumbbells': 'Adds another full tier to your horizontal rack, holding 800 lb on the 43 inch and 1,000 lb on the 70 inch.',
    'resistance-bands': 'For warm ups, stretching and assisted pull ups, squats and presses. The low impact way to add work without adding load.',
    'horizontal-roll-out-add-on': 'Converts your bottom tier into a roll out shelf in 11 gauge steel, so the heaviest weights slide out to you instead of you reaching under the rack.',
    'prx-rubber-hex-dumbbells-sets': 'Six sided rubber coated dumbbells that will not roll away and stay easy on your floor. Complete sets from light to heavy.'
  };

  /* v2.54: short blurb for the quick-look, from the product
     description's first paragraph (headings stripped, clipped at a
     sentence boundary) */
  function briefDesc(p) {
    if (!p.description) return '';
    var d = document.createElement('div');
    d.innerHTML = p.description;
    var hs = d.querySelectorAll('h1,h2,h3,h4,h5,h6');
    for (var i = 0; i < hs.length; i++) hs[i].parentNode.removeChild(hs[i]);
    var first = d.querySelector('p');
    var txt = ((first ? first.textContent : d.textContent) || '').replace(/\s+/g, ' ').trim();
    if (!txt) return '';
    if (txt.length > 160) {
      var cut = txt.slice(0, 160);
      var dot = cut.lastIndexOf('. ');
      txt = dot > 60 ? cut.slice(0, dot + 1) : cut.replace(/\s+\S*$/, '') + '\u2026';
    }
    return txt;
  }

  /* v2.53: the photos that belong to a variant. Chris's catalog tags
     every gallery image's alt text with the color it shows ("red
     battle rope anchor ..."), so the variant's set = image media whose
     alt starts with its color. Falls back to the variant's featured
     image, then the whole gallery. */
  function variantMedia(p, v) {
    var color = variantColor(p, v);
    var list = [];
    if (p.media && p.media.length && color) {
      var prefix = color.toLowerCase() + ' ';
      for (var k = 0; k < p.media.length; k++) {
        var md = p.media[k];
        if (md.media_type === 'image' && ((md.alt || '').toLowerCase() + ' ').indexOf(prefix) === 0 && md.src) {
          list.push(md.src);
        }
      }
    }
    if (!list.length && v.featured_image && v.featured_image.src) list.push(v.featured_image.src);
    if (!list.length && p.media) {
      for (var j = 0; j < p.media.length && list.length < 4; j++) {
        if (p.media[j].media_type === 'image' && p.media[j].src) list.push(p.media[j].src);
      }
    }
    return list.slice(0, 6);
  }

  function openQuickLook(p, startVid) {
    if (document.querySelector('.syn-ql')) return;
    var avail = p.variants.filter(function (v) { return v.available; });
    var vs = avail.length ? avail : p.variants;
    var cur = vs[0];
    for (var i = 0; i < vs.length; i++) { if (String(vs[i].id) === String(startVid)) { cur = vs[i]; break; } }
    var name = shortName(p.title);
    var sel = '';
    if (vs.length > 1) {
      sel = '<select class="syn-acc-variant" aria-label="Option">' + vs.map(function (v) {
        return '<option value="' + v.id + '" data-price="' + v.price + '"' + (v === cur ? ' selected' : '') + '>' + v.title + '</option>';
      }).join('') + '</select>';
    }
    var backdrop = document.createElement('div');
    backdrop.className = 'syn-ql-backdrop';
    var panel = document.createElement('div');
    panel.className = 'syn-ql';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', name);
    panel.innerHTML =
      '<button type="button" class="syn-ql-close" aria-label="Close"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<div class="syn-ql-inner">' +
        '<div class="syn-ql-media"><div class="syn-ql-imgwrap"><img class="syn-ql-img" src="" alt=""></div><div class="syn-ql-thumbs"></div></div>' +
        '<div class="syn-ql-body">' +
          '<p class="syn-ql-title">' + name + '</p>' +
          '<p class="syn-ql-price">' + money(cur.price) + '</p>' +
          '<p class="syn-ql-desc"></p>' +
          sel +
          '<div class="syn-ql-actions">' +
            '<div class="syn-ql-qty">' +
              '<button type="button" class="syn-ql-qbtn syn-ql-minus" aria-label="Decrease quantity" disabled><svg viewBox="0 0 12 12"><path d="M2 6h8"/></svg></button>' +
              '<input class="syn-ql-qval" type="number" min="1" max="99" value="1" aria-label="Quantity">' +
              '<button type="button" class="syn-ql-qbtn syn-ql-plus" aria-label="Increase quantity"><svg viewBox="0 0 12 12"><path d="M6 2v8M2 6h8"/></svg></button>' +
            '</div>' +
            '<button type="button" class="syn-ql-add" data-vid="' + cur.id + '">Add to Cart</button>' +
            '<a class="syn-ql-link" href="/products/' + p.handle + '">View full details</a>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(backdrop);
    document.body.appendChild(panel);
    var mainImg = panel.querySelector('.syn-ql-img');
    var thumbsEl = panel.querySelector('.syn-ql-thumbs');
    function setGallery(v) {
      var media = variantMedia(p, v);
      fadeSwap(mainImg, panel.querySelector('.syn-ql-imgwrap'), normImg(media[0] || (p.featured_image || ''), 720));
      thumbsEl.innerHTML = '';
      thumbsEl.style.display = media.length > 1 ? '' : 'none';
      media.forEach(function (src, idx) {
        var t = document.createElement('button');
        t.type = 'button';
        t.className = 'syn-ql-thumb';
        t.dataset.active = idx === 0 ? 'true' : '';
        t.setAttribute('aria-label', 'Photo ' + (idx + 1));
        t.innerHTML = '<img src="' + normImg(src, 120) + '" alt="" loading="lazy">';
        t.addEventListener('click', function () {
          fadeSwap(mainImg, panel.querySelector('.syn-ql-imgwrap'), normImg(src, 720));
          var all = thumbsEl.querySelectorAll('.syn-ql-thumb');
          for (var a = 0; a < all.length; a++) all[a].dataset.active = '';
          t.dataset.active = 'true';
        });
        thumbsEl.appendChild(t);
      });
    }
    setGallery(cur);
    requestAnimationFrame(function () {
      backdrop.classList.add('syn-ql-open');
      panel.classList.add('syn-ql-open');
    });
    var btn = panel.querySelector('.syn-ql-add');
    var descEl = panel.querySelector('.syn-ql-desc');
    var descTxt = BLURBS[p.handle] || briefDesc(p);
    if (descTxt) { descEl.textContent = descTxt; } else { descEl.parentNode.removeChild(descEl); }
    var s = panel.querySelector('.syn-acc-variant');
    if (s) {
      s.addEventListener('change', function () {
        var opt = s.options[s.selectedIndex];
        btn.dataset.vid = s.value;
        panel.querySelector('.syn-ql-price').textContent = money(parseInt(opt.dataset.price, 10));
        for (var i = 0; i < vs.length; i++) {
          if (String(vs[i].id) === s.value) { setGallery(vs[i]); break; }
        }
      });
      enhanceSelect(s);
    }
    /* v2.59: quantity stepper (Chris). Value is clamped 1-99 and read
       at add time, so typing or stepping both work. */
    var qEl = panel.querySelector('.syn-ql-qval');
    var minusEl = panel.querySelector('.syn-ql-minus');
    var plusEl = panel.querySelector('.syn-ql-plus');
    function qty() {
      var n = parseInt(qEl.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > 99) n = 99;
      return n;
    }
    function syncQty() {
      var n = qty();
      qEl.value = n;
      minusEl.disabled = n <= 1;
      plusEl.disabled = n >= 99;
    }
    minusEl.addEventListener('click', function () { qEl.value = qty() - 1; syncQty(); });
    plusEl.addEventListener('click', function () { qEl.value = qty() + 1; syncQty(); });
    qEl.addEventListener('change', syncQty);
    qEl.addEventListener('blur', syncQty);
    bindAdd(btn, function () { return btn.dataset.vid; }, panel.querySelector('.syn-ql-body'), qty);
    function close() {
      backdrop.classList.remove('syn-ql-open');
      panel.classList.remove('syn-ql-open');
      document.removeEventListener('keydown', onKey);
      setTimeout(function () {
        if (backdrop.parentNode) backdrop.parentNode.removeChild(backdrop);
        if (panel.parentNode) panel.parentNode.removeChild(panel);
      }, 230);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    backdrop.addEventListener('click', close);
    panel.querySelector('.syn-ql-close').addEventListener('click', close);
    document.addEventListener('keydown', onKey);
    panel.querySelector('.syn-ql-close').focus();
  }

  function cardFor(p) {
    var avail = p.variants.filter(function (v) { return v.available; });
    var vs = avail.length ? avail : p.variants;
    /* card image follows the selected variant; start on the default
       variant's own photo when it has one */
    var img = normImg(
      (vs[0].featured_image && vs[0].featured_image.src) ||
      p.featured_image || (p.images && p.images[0]) || ''
    );
    /* short name drops everything after the '|', but keep the 2x3/3x3
       spec visible - two landmines and two barbell holders otherwise
       read identically (Chris) */
    var name = shortName(p.title);
    var card = document.createElement('div');
    card.className = 'syn-acc-card';
    var sel = '';
    if (vs.length > 1) {
      sel = '<select class="syn-acc-variant" aria-label="Option">' + vs.map(function (v) {
        return '<option value="' + v.id + '" data-price="' + v.price + '">' + v.title + '</option>';
      }).join('') + '</select>';
    }
    var PLUS = '<svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg>';
    card.innerHTML =
      '<div class="syn-acc-tile">' +
        /* v2.70: EAGER, not lazy. The strip scrolls horizontally, so
           every card past the visible edge sat unloaded as a blank tile
           until the shopper swiped to it - and only ~2.4 of the 132px
           cards fit in a 345px phone strip, so cards 3 onward were
           empty on first sight for 71% of traffic. These are ~7KB each,
           so lazy was buying nothing and costing the carousel its first
           impression. */
        '<a href="/products/' + p.handle + '"><img class="syn-acc-img" loading="eager" decoding="async" src="' + img + '" alt=""></a>' +
        '<button type="button" class="syn-acc-add" data-vid="' + vs[0].id + '" aria-label="Add to cart">' + PLUS + '</button>' +
      '</div>' +
      '<p class="syn-acc-name"><a href="/products/' + p.handle + '">' + name + '</a></p>' +
      '<p class="syn-acc-price">' + money(vs[0].price) + '</p>' +
      sel;
    var s = card.querySelector('.syn-acc-variant');
    if (s) {
      s.addEventListener('change', function () {
        var opt = s.options[s.selectedIndex];
        card.querySelector('.syn-acc-add').dataset.vid = s.value;
        card.querySelector('.syn-acc-price').textContent = money(parseInt(opt.dataset.price, 10));
        /* swap the card photo to the selected color's variant image */
        for (var i = 0; i < vs.length; i++) {
          if (String(vs[i].id) === s.value) {
            if (vs[i].featured_image && vs[i].featured_image.src) {
              fadeSwap(card.querySelector('.syn-acc-img'), card.querySelector('.syn-acc-tile'), normImg(vs[i].featured_image.src));
            }
            break;
          }
        }
      });
      enhanceSelect(s);
    }
    card.querySelector('.syn-acc-add').addEventListener('click', function () {
      var btn = this;
      if (btn.dataset.busy) return;
      btn.dataset.busy = 'true';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(btn.dataset.vid, 10), quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        btn.dataset.done = 'true';
        btn.innerHTML = '<svg viewBox="0 0 24 24"><path d="M5 12l5 5 9-10"/></svg>';
        btn.setAttribute('aria-label', 'Added to cart');
        var toast = document.createElement('span');
        toast.className = 'syn-acc-toast';
        toast.textContent = 'Added to cart';
        btn.parentElement.appendChild(toast);
        setTimeout(function () { toast.remove(); }, 2000);
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return fetch('/cart.js').then(function (r2) { return r2.json(); }).then(function (c) {
          document.querySelectorAll('.header__cart-count').forEach(function (el) { el.textContent = c.item_count; });
          updateShip(c);
        });
      }).catch(function () {
        btn.dataset.fail = 'true';
        btn.innerHTML = '<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg>';
        btn.setAttribute('aria-label', 'Could not add, tap to retry');
      }).then(function () {
        setTimeout(function () {
          delete btn.dataset.busy; btn.dataset.done = ''; btn.dataset.fail = '';
          btn.innerHTML = '<svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg>';
          btn.setAttribute('aria-label', 'Add to cart');
        }, 2200);
      });
    });
    /* v2.52: plain click on the image or name opens the quick-look
       overlay instead of leaving the rack page; modified clicks
       (cmd/ctrl/shift/middle) still open the product page */
    var links = card.querySelectorAll('a');
    for (var li = 0; li < links.length; li++) {
      links[li].addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        e.preventDefault();
        openQuickLook(p, card.querySelector('.syn-acc-add').dataset.vid);
      });
    }
    return card;
  }

  function bindAdd(btn, getVid, host, getQty) {
    btn.addEventListener('click', function () {
      /* v2.48/2.49: sold-out upgrade variants become a notify-me
         trigger. The tile opens its own inline email form (synNotify
         handler) wired straight to the AMP Back in Stock API with the
         UPGRADE product's ids - we never call the app's on-page JS
         because its _BISConfig here is bound to the RACK product, which
         would subscribe visitors to the wrong restock list. If no
         handler is attached, fall back to deep-linking the product
         page. */
      if (btn.dataset.notify === 'true') {
        if (typeof btn.synNotifyHandler === 'function') { btn.synNotifyHandler(); }
        else { window.location.href = btn.dataset.notifyUrl; }
        return;
      }
      if (btn.dataset.busy) return;
      btn.dataset.busy = 'true';
      var restore = btn.innerHTML;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(getVid(), 10), quantity: getQty ? getQty() : 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        btn.dataset.done = 'true';
        btn.innerHTML = 'Added';
        var toast = document.createElement('span');
        toast.className = 'syn-acc-toast';
        toast.textContent = 'Added to cart';
        host.appendChild(toast);
        setTimeout(function () { toast.remove(); }, 2000);
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return fetch('/cart.js').then(function (r2) { return r2.json(); }).then(function (c) {
          document.querySelectorAll('.header__cart-count').forEach(function (el) { el.textContent = c.item_count; });
          updateShip(c);
        });
      }).catch(function () {
        btn.dataset.fail = 'true';
        btn.innerHTML = 'Try again';
      }).then(function () {
        setTimeout(function () {
          delete btn.dataset.busy; btn.dataset.done = ''; btn.dataset.fail = '';
          btn.innerHTML = restore;
        }, 2200);
      });
    });
  }

  /* v2.49: register a restock notification with the AMP Back in Stock
     app via its documented create endpoint (JSONP, so it works from any
     page and any product context). Success = {status:'OK'}. */
  function bisSignup(email, productNo, variantNo, cb) {
    var cbName = 'synBisCb' + Math.floor(Math.random() * 1e9);
    var done = false;
    var s = document.createElement('script');
    function cleanup() { delete window[cbName]; if (s.parentNode) s.parentNode.removeChild(s); }
    window[cbName] = function (resp) { if (done) return; done = true; clearTimeout(to); cleanup(); cb(null, resp); };
    var to = setTimeout(function () { if (done) return; done = true; cleanup(); cb(new Error('timeout')); }, 8000);
    s.onerror = function () { if (done) return; done = true; clearTimeout(to); cleanup(); cb(new Error('network')); };
    s.src = 'https://app.backinstock.org/stock_notification/create.json' +
      '?shop=' + encodeURIComponent((window.Shopify && window.Shopify.shop) || '69dde3.myshopify.com') +
      '&notification%5Bemail%5D=' + encodeURIComponent(email) +
      '&notification%5Bproduct_no%5D=' + encodeURIComponent(productNo) +
      '&notification%5Bquantity_required%5D=1' +
      '&notification%5Baccepts_marketing%5D=false' +
      '&notification%5Bcustomer_utc_offset%5D=' + encodeURIComponent(-(new Date()).getTimezoneOffset() * 60) +
      '&variant%5Bvariant_no%5D=' + encodeURIComponent(variantNo) +
      '&callback=' + cbName;
    document.head.appendChild(s);
  }

  function buildUpgrade(p, meta, choiceP) {
    /* v2.82: narrow to the one set that fits this rack, when the mapping
       named one. A missing SKU falls through to the whole product rather
       than rendering an empty tile - a stale mapping should degrade to
       the old behaviour, not to nothing. */
    var pool = p.variants;
    if (meta.variantSku) {
      var only = pool.filter(function (v) { return v.sku === meta.variantSku; });
      if (only.length) pool = only;
    }
    var avail = pool.filter(function (v) { return v.available; });
    /* allowSoldOut tiles render with every variant and a disabled Sold
       Out button; others skip so the app widget stays as fallback */
    var vs = avail.length ? avail : (meta.allowSoldOut ? pool : []);
    if (!vs.length) return null;
    var img = normImg(
      (vs[0].featured_image && vs[0].featured_image.src) ||
      p.featured_image || (p.images && p.images[0]) || ''
    );
    /* v2.85: the product the tile is currently selling. Starts as p and
       moves when the shopper picks the other handle style. */
    var curP = p;
    var opts = null;
    if (meta.choice && vs.length === 1 && choiceP && choiceP.variants && choiceP.variants.length) {
      var cAvail = choiceP.variants.filter(function (v) { return v.available; });
      var cVs = cAvail.length ? cAvail : (meta.allowSoldOut ? choiceP.variants : []);
      if (cVs.length) {
        var co = meta.choice.options;
        opts = [
          { p: p, v: vs[0], img: img, label: co[0].label, icon: co[0].icon, desc: co[0].desc },
          { p: choiceP, v: cVs[0], img: normImg((cVs[0].featured_image && cVs[0].featured_image.src) || choiceP.featured_image || (choiceP.images && choiceP.images[0]) || ''), label: co[1].label, icon: co[1].icon, desc: co[1].desc }
        ];
      }
    }
    var ICON = { arc: '<path d="M2 7 Q11 1 20 7"/>', bar: '<path d="M2 5 L20 5"/>' };
    var choiceHtml = opts ? '<div class="syn-upg-choice" role="radiogroup" aria-label="' + meta.choice.aria + '">' + opts.map(function (o, i) {
      return '<button type="button" class="syn-upg-opt" role="radio" aria-checked="' + (i === 0 ? 'true' : 'false') + '" data-i="' + i + '"><svg viewBox="0 0 22 10" aria-hidden="true">' + ICON[o.icon] + '</svg>' + o.label + '</button>';
    }).join('') + '</div>' : '';
    var tile = document.createElement('div');
    tile.className = 'syn-upg';
    var sel = '';
    if (vs.length > 1) {
      sel = '<select class="syn-acc-variant" aria-label="Option">' + vs.map(function (v) {
        return '<option value="' + v.id + '" data-price="' + v.price + '" data-avail="' + (v.available ? '1' : '0') + '">' + v.title + '</option>';
      }).join('') + '</select>';
    }
    tile.innerHTML =
      '<div class="syn-upg-imgwrap"><a href="/products/' + p.handle + '"><img class="syn-upg-img" loading="lazy" src="' + img + '" alt=""></a></div>' +
      '<div class="syn-upg-body">' +
        '<span class="syn-upg-badge">Upgrade</span>' +
        '<p class="syn-upg-title"><a href="/products/' + p.handle + '">' + (opts ? meta.choice.title : meta.title) + '</a></p>' +
        '<p class="syn-upg-desc">' + (opts ? opts[0].desc : meta.desc) + '</p>' +
        choiceHtml +
        '<div class="syn-upg-row">' +
          '<span class="syn-upg-price">' + money(vs[0].price) + '</span>' +
          sel +
          '<button type="button" class="syn-upg-add" data-vid="' + vs[0].id + '">Add</button>' +
        '</div>' +
      '</div>';
    var s = tile.querySelector('.syn-acc-variant');
    var btn = tile.querySelector('.syn-upg-add');
    function removeNotifyForm() {
      var el = tile.querySelector('.syn-upg-notify, .syn-upg-notified, .syn-upg-notify-err');
      while (el) { el.parentNode.removeChild(el); el = tile.querySelector('.syn-upg-notify, .syn-upg-notified, .syn-upg-notify-err'); }
      btn.style.display = '';
    }
    function setBtnAvail(isAvail) {
      var tag = tile.querySelector('.syn-upg-tag');
      if (isAvail) {
        btn.disabled = false;
        btn.textContent = 'Add';
        btn.dataset.notify = '';
        delete btn.dataset.notifyUrl;
        removeNotifyForm();
        if (tag) tag.parentNode.removeChild(tag);
      } else {
        btn.disabled = false;
        btn.textContent = 'Notify Me When Available';
        btn.dataset.notify = 'true';
        btn.dataset.notifyUrl = '/products/' + curP.handle + '?variant=' + btn.dataset.vid;
        if (!tag) {
          tag = document.createElement('span');
          tag.className = 'syn-upg-tag';
          tag.textContent = 'Sold Out';
          var priceEl = tile.querySelector('.syn-upg-price');
          priceEl.parentNode.insertBefore(tag, priceEl.nextSibling);
        }
      }
    }
    /* v2.49: inline signup, same page. Click swaps in an email field;
       submit registers with AMP for the SELECTED variant. Any API
       failure falls back to the product page, where the app's own form
       lives - a shopper never hits a dead end. */
    btn.synNotifyHandler = function () {
      if (tile.querySelector('.syn-upg-notify')) return;
      removeNotifyForm();
      var row = tile.querySelector('.syn-upg-row');
      var form = document.createElement('div');
      form.className = 'syn-upg-notify';
      form.innerHTML = '<input type="email" class="syn-upg-email" placeholder="you@email.com" aria-label="Email address for restock alert">' +
        '<button type="button" class="syn-upg-notify-go">Notify Me</button>';
      row.parentNode.appendChild(form);
      btn.style.display = 'none';
      var input = form.querySelector('.syn-upg-email');
      var go = form.querySelector('.syn-upg-notify-go');
      input.focus();
      function submit() {
        var email = (input.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          input.style.borderColor = '#e4574f';
          return;
        }
        go.disabled = true;
        go.textContent = '...';
        bisSignup(email, curP.id, parseInt(btn.dataset.vid, 10), function (err, resp) {
          if (!err && resp && resp.status === 'OK') {
            var okEl = document.createElement('p');
            okEl.className = 'syn-upg-notified';
            okEl.textContent = 'You’re on the list. We’ll email you when it’s back.';
            form.parentNode.replaceChild(okEl, form);
          } else if (!err && resp && resp.errors) {
            go.disabled = false;
            go.textContent = 'Notify Me';
            var msgs = [];
            for (var k in resp.errors) { if (resp.errors[k] && resp.errors[k].length) msgs.push(resp.errors[k][0]); }
            var errEl = tile.querySelector('.syn-upg-notify-err') || document.createElement('p');
            errEl.className = 'syn-upg-notify-err';
            errEl.textContent = msgs[0] || 'That didn’t go through. Try again.';
            form.parentNode.appendChild(errEl);
          } else {
            /* endpoint unreachable: hand off to the product page */
            window.location.href = btn.dataset.notifyUrl;
          }
        });
      }
      go.addEventListener('click', submit);
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') submit(); });
    };
    setBtnAvail(!!vs[0].available);
    if (s) {
      s.addEventListener('change', function () {
        var opt = s.options[s.selectedIndex];
        btn.dataset.vid = s.value;
        tile.querySelector('.syn-upg-price').textContent = money(parseInt(opt.dataset.price, 10));
        setBtnAvail(opt.dataset.avail === '1');
        for (var i = 0; i < vs.length; i++) {
          if (String(vs[i].id) === s.value) {
            if (vs[i].featured_image && vs[i].featured_image.src) {
              fadeSwap(tile.querySelector('.syn-upg-img'), tile.querySelector('.syn-upg-imgwrap'), normImg(vs[i].featured_image.src));
            }
            break;
          }
        }
      });
      enhanceSelect(s);
    }
    if (opts) {
      var optBtns = tile.querySelectorAll('.syn-upg-opt');
      var pick = function (i) {
        var o = opts[i];
        if (o.p === curP && String(o.v.id) === btn.dataset.vid) return;
        for (var j = 0; j < optBtns.length; j++) optBtns[j].setAttribute('aria-checked', j === i ? 'true' : 'false');
        curP = o.p;
        btn.dataset.vid = o.v.id;
        var links = tile.querySelectorAll('.syn-upg-imgwrap a, .syn-upg-title a');
        for (var k = 0; k < links.length; k++) links[k].setAttribute('href', '/products/' + o.p.handle);
        tile.querySelector('.syn-upg-desc').textContent = o.desc;
        tile.querySelector('.syn-upg-price').textContent = money(o.v.price);
        removeNotifyForm();
        setBtnAvail(!!o.v.available);
        if (o.img) fadeSwap(tile.querySelector('.syn-upg-img'), tile.querySelector('.syn-upg-imgwrap'), o.img);
      };
      for (var q = 0; q < optBtns.length; q++) {
        optBtns[q].addEventListener('click', (function (i) { return function () { pick(i); }; })(q));
      }
      /* arrow keys move the selection, as a radio group should */
      tile.querySelector('.syn-upg-choice').addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var cur = 0;
        for (var j = 0; j < optBtns.length; j++) if (optBtns[j].getAttribute('aria-checked') === 'true') cur = j;
        var nx = (cur + (e.key === 'ArrowRight' ? 1 : optBtns.length - 1)) % optBtns.length;
        pick(nx); optBtns[nx].focus();
      });
    }
    bindAdd(btn, function () { return btn.dataset.vid; }, tile);
    return tile;
  }

  function buildCarousel(products, stripLabel) {
    var wrap = document.createElement('div');
    wrap.className = 'syn-acc';
    wrap.innerHTML = '<p class="syn-acc-label">' + (stripLabel || 'Pick Your Accessories') + '</p><div class="syn-acc-strip-wrap"><button type="button" class="syn-acc-arrow syn-acc-arrow--prev" aria-label="Scroll accessories left" hidden><svg viewBox="0 0 24 24"><path d="M15 6l-6 6 6 6"/></svg></button><div class="syn-acc-strip"></div><button type="button" class="syn-acc-arrow syn-acc-arrow--next" aria-label="Scroll accessories right"><svg viewBox="0 0 24 24"><path d="M9 6l6 6-6 6"/></svg></button></div><div class="syn-ship"><div class="syn-ship-inner"><div class="syn-ship-row"><p class="syn-ship-text"></p><span class="syn-ship-target">Free shipping at $249</span></div><div class="syn-ship-track"><span class="syn-ship-truck">' + SHIP_TRUCK + '</span><div class="syn-ship-bar"><div class="syn-ship-fill"></div></div></div><p class="syn-ship-fine">Threshold applies to your subtotal after any discount code.</p></div></div>';
    var strip = wrap.querySelector('.syn-acc-strip');
    products.forEach(function (p) { strip.appendChild(cardFor(p)); });
    var prev = wrap.querySelector('.syn-acc-arrow--prev');
    var next = wrap.querySelector('.syn-acc-arrow--next');
    function sync() {
      prev.hidden = strip.scrollLeft < 10;
      next.hidden = strip.scrollLeft > strip.scrollWidth - strip.clientWidth - 10;
      strip.classList.toggle('syn-acc-scrolled', strip.scrollLeft > 4);
    }
    prev.addEventListener('click', function () { strip.scrollBy({ left: -270, behavior: 'smooth' }); });
    next.addEventListener('click', function () { strip.scrollBy({ left: 270, behavior: 'smooth' }); });
    strip.addEventListener('scroll', sync, { passive: true });
    setTimeout(sync, 300);
    return wrap;
  }


  /* ===== v2.62: mount-point diagram removed at Chris's call.
     Its hero-photo hotspot band lived here; the gallery crossfade
     below is unrelated and stays. ===== */

  /* #5: crossfade the gallery on a color change. v2.61c, after
     tracing the real behavior twice: the Power Picker gallery does not
     swap an image src (v2.61a assumption) and does not swap img nodes
     inside stable slides (v2.61b assumption) - it TEARS DOWN AND
     REBUILDS the entire gallery wrapper, so no element survives to
     animate. The approach that works: snapshot the visible frame at
     the moment the color is clicked, hold that snapshot over the
     gallery while the new one is built, then fade it out once the
     replacement has actually painted. Skipped under
     prefers-reduced-motion. */
  var xfadeBusy = false;
  function mainGalleryImg() {
    var best = null, bestW = 0;
    var imgs = document.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      if (im.closest && im.closest('.syn-ql, .syn-acc, .syn-upg, header, footer')) continue;
      var u = im.currentSrc || im.src || '';
      if (u.indexOf('/files/') === -1) continue;
      var r = im.getBoundingClientRect();
      if (r.width < 260 || r.height < 260) continue;
      if (r.bottom < 0 || r.top > window.innerHeight) continue;
      if (r.width > bestW) { bestW = r.width; best = { el: im, rect: r, src: u }; }
    }
    return best;
  }
  function crossfadeFrom(snap) {
    if (!snap) return;
    xfadeBusy = true;
    var ghost = document.createElement('img');
    ghost.className = 'syn-xfade';
    ghost.src = snap.src;
    ghost.style.left = snap.rect.left + 'px';
    ghost.style.top = snap.rect.top + 'px';
    ghost.style.width = snap.rect.width + 'px';
    ghost.style.height = snap.rect.height + 'px';
    document.body.appendChild(ghost);
    var started = Date.now();
    function done() {
      ghost.style.opacity = '0';
      setTimeout(function () {
        if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
        xfadeBusy = false;
      }, 400);
    }
    /* hold the old frame until the rebuilt gallery has painted a
       different image, or 1.6s, whichever comes first */
    (function wait() {
      var cur = mainGalleryImg();
      var ready = cur && cur.src.split('?')[0] !== snap.src.split('?')[0] && cur.el.complete && cur.el.naturalWidth > 0;
      if (ready || Date.now() - started > 1600) { done(); return; }
      requestAnimationFrame(wait);
    })();
  }
  function initGalleryCrossfade() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.addEventListener('click', function (e) {
      if (xfadeBusy || !e.target || !e.target.closest) return;
      if (!e.target.closest('.rio-options, .block-swatch, .color-swatch, [class*="pwzr"]')) return;
      if (e.target.closest('.syn-acc, .syn-upg, .syn-ql')) return;
      var snap = mainGalleryImg();
      if (!snap) return;
      requestAnimationFrame(function () { crossfadeFrom(snap); });
    }, true);
  }

  /* v2.89: Chris, on the v2.88 strip: "u can definitely improve the look of
     the complete ancore setup. make it look premium". Two cards in a
     carousel built for six read as a half-empty shelf. ANCORE pages now get
     ONE composed card instead: a small eyebrow, a title, one row per
     product (photo, name, price, one factual line, size pills, Add), and a
     closing line that says plainly who ships it. Light only, brand blue and
     #222, same fonts as the page, and the word "premium" appears nowhere
     (2026-08-13 rejection). Image and name still open the quick-look; Add
     goes through the same bindAdd as every other tile. Copy per product is
     ANCORE's own facts only. */
  var ANCORE_LINE = {
    'ancore-pro': 'The trainer itself. 5 to 55 lb at a true 1:1, strap mount included.',
    'resistance-plates': 'Add-on pairs that twist on. The ~10s take the Pro toward 65 lb.',
    'plate-dock': 'Keeps spare plates on your rack or wall, right by the unit.'
  };
  function ancoreCss() {
    if (document.getElementById('syn-anc-css')) return;
    var st = document.createElement('style');
    st.id = 'syn-anc-css';
    st.textContent =
      '.syn-anc{margin:22px 0 18px;background:#fff;border:1px solid #e7e7e7;border-radius:16px;padding:20px 20px 14px;box-shadow:0 1px 2px rgba(0,0,0,.03),0 8px 24px rgba(0,0,0,.04)}' +
      '.syn-anc .syn-anc-eyebrow{margin:0 0 4px;font:600 11px/1.2 Poppins,sans-serif;letter-spacing:.14em;text-transform:uppercase;color:#26B1FD}' +
      '.syn-anc-title{margin:0 0 6px;font:600 19px/1.25 Poppins,sans-serif;color:#222;letter-spacing:-.01em}' +
      '.syn-anc *{letter-spacing:0}' +
      '.syn-anc-row{display:grid;grid-template-columns:84px 1fr;column-gap:16px;row-gap:12px;padding:16px 0;border-top:1px solid #f0f0f0}' +
      '.syn-anc-act{grid-column:2}' +
      '.syn-anc-row:first-of-type{border-top:0}' +
      /* v2.90: position:relative is load-bearing. fadeSwap's ghost image is
         position:absolute at 100% of the nearest positioned ancestor; without
         this it sized to the page and flashed huge for ~0.3s on every option
         tap (Chris: "it shows it really big for like .2 seconds") */
      '.syn-anc-img{position:relative;display:block;width:84px;height:84px;border-radius:12px;background:#f5f5f5;overflow:hidden}' +
      '.syn-anc-img .syn-imgghost{padding:0;mix-blend-mode:multiply}' +
      '.syn-anc-img img{width:100%;height:100%;object-fit:contain;mix-blend-mode:multiply;transition:transform .5s cubic-bezier(.2,.7,.2,1)}' +
      '.syn-anc-row:hover .syn-anc-img img{transform:scale(1.04)}' +
      '.syn-anc-top{display:flex;justify-content:space-between;align-items:baseline;gap:12px}' +
      '.syn-anc-name{font:600 15px/1.3 Poppins,sans-serif;color:#222;text-decoration:none}' +
      '.syn-anc-name:hover{color:#26B1FD}' +
      '.syn-anc-price{font:500 15px/1.3 Poppins,sans-serif;color:#222;white-space:nowrap}' +
      '.syn-anc-desc{margin:4px 0 0;font-size:13px;line-height:1.5;color:#6b6b6b}' +
      '.syn-anc-act{display:flex;align-items:center;justify-content:space-between;gap:10px;flex-wrap:wrap}' +
      '.syn-anc-pills{display:flex;gap:6px;flex-wrap:wrap}' +
      '.syn-anc-pill{appearance:none;cursor:pointer;height:30px;padding:0 12px;border-radius:999px;border:1px solid #dcdcdc;background:#fff;color:#444;font:500 12px/28px Poppins,sans-serif;transition:border-color .2s,background .2s,color .2s}' +
      '.syn-anc-pill:hover{border-color:#999}' +
      '.syn-anc-pill[aria-pressed="true"]{border-color:#26B1FD;background:#eef8ff;color:#0b6ea3}' +
      '.syn-anc .syn-anc-add{appearance:none;cursor:pointer;margin-left:auto;height:34px;min-width:76px;padding:0 18px;border-radius:999px;border:1.5px solid #222;background:#fff;color:#222;font:600 12px/31px Poppins,sans-serif;letter-spacing:.08em;text-transform:uppercase;transition:background .2s,color .2s,border-color .2s}' +
      '.syn-anc-add:hover{background:#222;color:#fff}' +
      '.syn-anc-add[data-done="true"]{background:#26B1FD;border-color:#26B1FD;color:#000}' +
      '.syn-anc-add[data-fail="true"]{border-color:#c0392b;color:#c0392b;background:#fff}' +
      '.syn-anc .syn-acc-toast{display:none}' +
      '.syn-anc-foot{display:flex;align-items:center;gap:8px;margin:2px 0 0;padding-top:12px;border-top:1px solid #f0f0f0;font-size:12px;line-height:1.4;color:#8a8a8a}' +
      '.syn-anc-foot svg{flex:0 0 16px;width:16px;height:16px;fill:none;stroke:#8a8a8a;stroke-width:1.6}' +
      '@media (max-width:480px){.syn-anc{padding:18px 16px 12px}.syn-anc-row{grid-template-columns:72px 1fr;column-gap:14px}.syn-anc-img{width:72px;height:72px}.syn-anc-act{grid-column:1/-1}}';
    document.head.appendChild(st);
  }
  function pillLabel(t) {
    return String(t || '').replace(/\s*Resistance Plates$/i, '').replace(/\blbs\b/i, 'lb').replace(/\s+Mounted$/i, ' mount');
  }
  function pillNum(t) { var m = String(t).match(/([\d.]+)/); return m ? parseFloat(m[1]) : 0; }
  function buildAncoreSetup(products, label) {
    ancoreCss();
    var wrap = document.createElement('div');
    wrap.className = 'syn-acc syn-anc';
    wrap.innerHTML = '<p class="syn-anc-eyebrow">The ANCORE System</p><p class="syn-anc-title">' + (label || 'Complete Your ANCORE Setup') + '</p>';
    products.forEach(function (p) {
      var vs = p.variants.filter(function (v) { return v.available; });
      if (!vs.length) return;
      var cur = vs[0];
      var img = normImg(p.featured_image || (p.images && p.images[0]), 240);
      var name = shortName(p.title);
      var row = document.createElement('div');
      row.className = 'syn-anc-row';
      var pills = '';
      if (vs.length > 1) {
        /* shown smallest to largest, but the first variant (ANCORE's own
           default, the ~10 lb pair on the plates) stays pre-selected */
        var sorted = vs.slice().sort(function (a, b) { return pillNum(a.title) - pillNum(b.title); });
        pills = '<div class="syn-anc-pills" role="group" aria-label="Option">' + sorted.map(function (v) {
          return '<button type="button" class="syn-anc-pill" data-vid="' + v.id + '" aria-pressed="' + (v === cur ? 'true' : 'false') + '">' + pillLabel(v.title) + '</button>';
        }).join('') + '</div>';
      }
      row.innerHTML =
        '<a class="syn-anc-img" href="/products/' + p.handle + '"><img loading="eager" decoding="async" src="' + img + '" alt="' + name.replace(/"/g, '&quot;') + '"></a>' +
        '<div class="syn-anc-body">' +
          '<div class="syn-anc-top"><a class="syn-anc-name" href="/products/' + p.handle + '">' + name + '</a><span class="syn-anc-price">' + money(cur.price) + '</span></div>' +
          (ANCORE_LINE[p.handle] ? '<p class="syn-anc-desc">' + ANCORE_LINE[p.handle] + '</p>' : '') +
        '</div>' +
        '<div class="syn-anc-act">' + pills + '<button type="button" class="syn-anc-add" aria-label="Add ' + name.replace(/"/g, '&quot;') + ' to cart">Add</button></div>';
      var vid = String(cur.id);
      var priceEl = row.querySelector('.syn-anc-price');
      var pillEls = row.querySelectorAll('.syn-anc-pill');
      for (var i = 0; i < pillEls.length; i++) {
        pillEls[i].addEventListener('click', function () {
          vid = this.dataset.vid;
          for (var j = 0; j < pillEls.length; j++) pillEls[j].setAttribute('aria-pressed', pillEls[j] === this ? 'true' : 'false');
          for (var k = 0; k < vs.length; k++) {
            if (String(vs[k].id) === vid) {
              priceEl.textContent = money(vs[k].price);
              if (vs[k].featured_image && vs[k].featured_image.src) {
                fadeSwap(row.querySelector('.syn-anc-img img'), row.querySelector('.syn-anc-img'), normImg(vs[k].featured_image.src, 240));
              }
              break;
            }
          }
        });
      }
      bindAdd(row.querySelector('.syn-anc-add'), function () { return vid; }, row.querySelector('.syn-anc-act'));
      var links = row.querySelectorAll('a');
      for (var li = 0; li < links.length; li++) {
        links[li].addEventListener('click', function (e) {
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
          e.preventDefault();
          openQuickLook(p, vid);
        });
      }
      wrap.appendChild(row);
    });
    var foot = document.createElement('p');
    foot.className = 'syn-anc-foot';
    foot.innerHTML = '<svg viewBox="0 0 24 24"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg><span>Ships direct from ANCORE. Shipping is calculated at checkout.</span>';
    wrap.appendChild(foot);
    return wrap;
  }

  function initAccCarousel(attempt) {
    attempt = attempt || 0;
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m || (!FAMILIES[m[1]] && !STORAGE[m[1]])) return;
    if (document.querySelector('.syn-acc')) return;
    /* v2.40: sits ABOVE the add-to-cart button (where SellEasy's block
       lived), per Chris - inserted BEFORE the buy buttons. Fallbacks
       (chip/badges, inserted after) only if the buy buttons never
       appear. */
    var bb = document.querySelector('.product-form__buy-buttons:not(.product-sticky-form .product-form__buy-buttons)');
    var chip = document.querySelector('.syn-vidrev-chip');
    var badges = document.querySelector('.syn-badges[data-syn-moved="true"]');
    var target = bb || chip || badges;
    if (!target) {
      if (attempt < 240) { requestAnimationFrame(function () { initAccCarousel(attempt + 1); }); }
      return;
    }
    /* v2.66: accessory strip for gear that takes accessories, storage
       strip for free weights - and never show a product to itself */
    var isStorage = !FAMILIES[m[1]] && !!STORAGE[m[1]];
    /* keep the ORIGINAL array reference: the upgrade-tile checks below
       compare by identity, and .filter() would hand them a new array */
    var baseList = isStorage ? STORAGE[m[1]] : FAMILIES[m[1]];
    var handles = baseList.filter(function (h) { return h !== m[1]; });
    var stripLabel = STRIP_LABEL[m[1]] || (isStorage ? 'Store Them' : 'Pick Your Accessories');
    /* v2.47: the dumbbell-sets tile belongs on dumbbell racks only -
       plate trees, kettlebell racks and PK hybrids get no upgrade tile
       (their app modules stay as-is) */
    var isHoriz = baseList === HORIZ_FULL || baseList === HORIZ_A4 || baseList === HORIZ_D6;
    /* v2.81: VERT_MOUNT_NOACC is an empty accessory list, but the page
       is still a dumbbell rack and still earns the dumbbell tile */
    var isDumbbellRack = baseList === VERT_DB_STD || baseList === ADJ_LIST || baseList === VERT_MOUNT_NOACC;
    /* v2.81: a per-handle override wins over the family default */
    var upg = UPGRADE_OK[m[1]] ? (UPGRADE_BY_HANDLE[m[1]] || (isHoriz ? UPGRADES.horiz : (isDumbbellRack ? UPGRADES.vert : null))) : null;
    /* v2.67: never offer a page itself, or a sibling of itself */
    if (upg && (upg.handle === m[1] || UPGRADE_SELF[m[1]])) upg = null;
    /* v2.82: nothing to draw at all, so bail BEFORE the skeleton rather
       than flashing a shimmer that resolves to nothing */
    if (!handles.length && !upg) return;
    var anchor = target === bb ? target : target.nextSibling;
    /* v2.52: skeleton shimmer holds the space while product data loads,
       so the carousel stops popping in */
    var skel = document.createElement('div');
    skel.className = 'syn-acc-skel';
    var skelCard = '<div class="syn-acc-skel-card"><div class="syn-acc-skel-img syn-acc-shimmer"></div><div class="syn-acc-skel-line syn-acc-shimmer"></div><div class="syn-acc-skel-line syn-acc-skel-line--short syn-acc-shimmer"></div></div>';
    skel.innerHTML = '<div class="syn-acc-skel-label syn-acc-shimmer"></div><div class="syn-acc-skel-row">' + skelCard + skelCard + skelCard + skelCard + '</div>';
    target.parentNode.insertBefore(skel, anchor);
    /* v2.52: the rack's own product data rides along so the accessories
       can follow the rack's selected color */
    /* v2.85: a tile with a handle choice also fetches the second set */
    var choiceH = upg && upg.choice && upg.choice.options[1] && upg.choice.options[1].handle;
    var extra = upg ? (choiceH ? [upg.handle, choiceH, m[1]] : [upg.handle, m[1]]) : [m[1]];
    var fetches = handles.concat(extra).map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    });
    Promise.all(fetches).then(function (ps) {
      if (skel.parentNode) skel.parentNode.removeChild(skel);
      rackP = ps[ps.length - 1];
      var upgP = upg ? ps[handles.length] : null;
      var choiceP = choiceH ? ps[handles.length + 1] : null;
      var accPs = ps.slice(0, handles.length);
      var ok = accPs.filter(function (p) { return p && p.variants && p.variants.length; });
      if (!ok.length && !upgP) return;
      /* premium upgrade tile first, then the accessories carousel. The
         app's own module is hidden ONLY when the native tile actually
         rendered (product loaded AND has an in-stock variant); otherwise
         the app widget stays as the fallback. */
      if (upgP && upgP.variants) {
        var tile = buildUpgrade(upgP, upg, choiceP);
        if (tile) {
          target.parentNode.insertBefore(tile, anchor);
          document.documentElement.classList.add(upg.cls);
        }
      }
      if (ok.length) {
        document.documentElement.classList.add('syn-acc-native');
        /* v2.89: ANCORE pages draw the composed card, not the strip */
        var accWrap = ANCORE_FAMILY[m[1]] ? buildAncoreSetup(ok, stripLabel) : buildCarousel(ok, stripLabel);
        /* v2.88: no free-shipping meter on ANCORE pages, see NO_SHIP_METER */
        if (NO_SHIP_METER[m[1]]) {
          var meter = accWrap.querySelector('.syn-ship');
          if (meter) meter.parentNode.removeChild(meter);
        }
        target.parentNode.insertBefore(accWrap, anchor);
        refreshShip();
        /* v2.52: keep the accessories in the rack's color. Any change
           or click in the variant-picker area re-syncs (debounced);
           the guard skips our own card selects, which live inside the
           same form. */
        /* v2.63: sync in a BURST rather than on one 250ms debounce.
           The rack's variant can land anywhere from ~100ms to a couple
           of seconds after the click depending on device and network,
           and a single timer that fires too early reads the OLD colour
           and appears to do nothing. Each pass is idempotent, so
           repeating it is free. */
        var burstTimers = [];
        function resync() {
          for (var t = 0; t < burstTimers.length; t++) clearTimeout(burstTimers[t]);
          burstTimers = [120, 350, 800, 1500, 2600, 4000].map(function (ms) {
            return setTimeout(function () { syncAccAll(); }, ms);
          });
        }
        document.addEventListener('change', function (e) {
          if (!e.target || !e.target.closest) return;
          if (e.target.className && String(e.target.className).indexOf('syn-acc-variant') !== -1) return;
          if (e.target.closest('form[action*="/cart/add"], .rio-options, variant-picker')) resync();
        }, true);
        document.addEventListener('click', function (e) {
          if (!e.target || !e.target.closest) return;
          if (e.target.closest('.syn-swatch, .syn-pill-swatches, .rio-options, .block-swatch, .color-swatch')) resync();
        }, true);
        /* the picker updates the URL, so history changes are a second,
           independent trigger */
        window.addEventListener('popstate', resync);
        var lastSeenVariant = null;
        setInterval(function () {
          var m2 = location.search.match(/[?&]variant=(\d+)/);
          var v = m2 ? m2[1] : null;
          if (v !== lastSeenVariant) { lastSeenVariant = v; syncAccAll(); }
        }, 700);
        resync();
      }
    });
  }
  function initUpsellExtras() {
    initAccCarousel();
    initGalleryCrossfade();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUpsellExtras);
  } else {
    initUpsellExtras();
  }
})();
